import i18next from "i18next";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { Tooltip } from "react-tooltip";
import ChangeDrugStatusTableSelect from "../components/DrugComponents/ChangeDrugStatusTableSelect";
import GeneralImage from "../components/GeneralComponents/GeneralImage";
import Loader from "../components/GeneralComponents/Loader";
import CartTableItemQuantityItem from "../components/OrdersComponents/CartTableItemQuantityItem";
import ReturnedOrderTableQuantityItem from "../components/OrdersComponents/ReturnedOrderTableQuantityItem";
import SharedCartTableItemQuantityItem from "../components/OrdersComponents/SharedCartTableItemQuantityItem";
import ChangeProductStatusTableSelect from "../components/ProductComponents/ChangeProductStatusTableSelect";
import { logout } from "../redux/slices/authSlice";
import { ToggleShowGeneralToast } from "../redux/slices/generalToastSlice";
import {
  clearOfferType,
  clearTotalPrices,
  updateOfferItemDetails,
  updateOfferStep,
  updateOfferType,
} from "../redux/slices/offerSlice";
import {
  handleSetEditRequestTimeOutClicked,
  handleSetGetStartedActivated,
  handleSetGetStartedActivatedForReturned,
  handleSetGetStartedActivatedForSpecific,
  handleSetTimeoutCount,
  handleSethasUserEditedOnce,
} from "../redux/slices/orderSessionStorage";
import {
  handleGetSelectedOrder,
  handleIsOrderRequestTimerActive,
  handleIsPreventUserNavigation,
  handlePreventUserToLeave,
  handleSetTotalPriceForSelectedItems,
  handleUpdateSelectedRequestTableItems,
} from "../redux/slices/orderSlice";
import { RootState, store } from "../redux/store";
import { TableKey, TableRow } from "../types";
import { IOfferItem } from "../types/Offer";
import {
  ArabicCode,
  BASE_Images_API_URL,
  BASE_LOCAL_IMAGES_DIR,
  DefaultPharmacyOffersSearchLocalStorageKey,
  DefaultProductExcelImage,
  DrugStatusEnum,
  GlobalSyrianCurrentLabelAr,
  GlobalSyrianCurrentLabelEn,
  GlobalToasterDuration,
  OfferTypesEnum,
  OrderStatusEnum,
  OrderTypesEnum,
  ProductStatusEnum,
  ProfileTabsEnum,
  ToasterErrorImageUrl,
} from "./constants/CommonConstants";
import {
  all_warehouses_star_IMG,
  drugs_IMG,
  incoming_order_blue_arrow_IMG,
  incoming_order_orange_arrow_IMG,
  offer_icon_IMG,
  orange_flag_IMG,
  percentage_sign_IMG,
  star_IMG,
} from "./constants/Images";

import { SharedCartOrder } from "../redux/slices/sharedCartSlice";
import {
  INormalizedSharedCart,
  ISharedCart,
  SharedCartItem,
  SharedCartItemType,
} from "../types/apis/shared-cart";

export const getCurrentStyleDirection = (): string => {
  let currentStyleDirection = localStorage.getItem("style-direction");
  if (!currentStyleDirection) {
    currentStyleDirection = "ltr";
  }
  return currentStyleDirection;
};

export const getTomorrowDate = (): string => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  return tomorrow.toISOString().split("T")[0];
};

export const getQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const start = parseInt(urlParams.get("start") || "0", 10);
  const pageSize = parseInt(urlParams.get("pageSize") || "5", 10);
  const facility_id = parseInt(urlParams.get("facility_id") || "", 10);
  const account_id = parseInt(urlParams.get("account_id") || "", 10);
  const facility_type_id = parseInt(
    urlParams.get("facility_type_id") || "",
    10,
  );
  const is_active = urlParams.get("is_active");
  const CityId = urlParams.get("CityId");
  const AreaId = urlParams.get("AreaId");
  const verified_facility = urlParams.get("verified_facility");
  const is_verified = urlParams.get("is_verified");
  const offer_type = urlParams.get("offer_type");
  const order_status = urlParams.get("order_status");
  const product_status = urlParams.get("product_status");
  const order_type = urlParams.get("order_type");
  const delivery_date = urlParams.get("delivery_date");
  const start_date = urlParams.get("start_date");
  const end_date = urlParams.get("end_date");
  const warehouse_id = parseInt(urlParams.get("warehouse_id") || "", 10);
  const drug_pharmaceuticals_facility_id = parseInt(
    urlParams.get("drug_pharmaceuticals_facility_id") || "",
    10,
  );
  const pharmacy_id = parseInt(urlParams.get("pharmacy_id") || "", 10);
  const priority = parseInt(urlParams.get("priority") || "", 10);

  return {
    start,
    pageSize,
    facility_id,
    account_id,
    facility_type_id,
    is_active,
    CityId,
    AreaId,
    verified_facility,
    is_verified,
    offer_type,
    warehouse_id,
    pharmacy_id,
    order_status,
    order_type,
    product_status,
    delivery_date,
    drug_pharmaceuticals_facility_id,
    priority,
    start_date,
    end_date,
  };
};

export function convertTimestampToDate(
  timeStamp: string | number | null,
): string {
  // If the timestamp is a string, replace any commas with dots.
  if (typeof timeStamp === "string") {
    timeStamp = timeStamp.replace(/[٫,]/g, ".");
  }

  // Convert the timestamp to a number and floor it to remove any decimals.
  const timeStampInt = Math.floor(Number(timeStamp));

  if (isNaN(timeStampInt)) {
    return "Invalid Date";
  }

  // Create a Date object from the timestamp (assuming timestamp is in seconds)
  const date = new Date(timeStampInt * 1000);

  // Return the ISO date string (YYYY-MM-DD) which is reliably parsed by Date
  return date.toISOString().split("T")[0];
}

export const handleOfferItemChange = (
  row: any,
  field: string,
  value: number | null,
) => {
  // const currentItem = store
  //   .getState()
  //   .offer.offerItems.find((item: any) => item.Id === row.Id);

  const currentItem = (
    store.getState() as unknown as RootState
  ).offer.offerItems.find((item: any) => item.Id === row.Id);

  // Ensure value is either a valid number or null (empty)
  if (value !== null && value >= 0) {
    if (field === "Quantity") {
      store.dispatch(
        updateOfferItemDetails({
          Id: row.Id,
          Quantity: value,
          FreeQuantity: currentItem?.FreeQuantity ?? null,
          Discount: currentItem?.Discount ?? null,
          NetPrice: currentItem?.NetPrice ?? 0,
        }),
      );
    }

    if (field === "FreeQuantity") {
      store.dispatch(
        updateOfferItemDetails({
          Id: row.Id,
          Quantity: currentItem?.Quantity ?? null,
          FreeQuantity: value,
          Discount: currentItem?.Discount ?? null,
          NetPrice: currentItem?.NetPrice ?? 0,
        }),
      );
    }

    if (field === "Discount") {
      store.dispatch(
        updateOfferItemDetails({
          Id: row.Id,
          Quantity: currentItem?.Quantity ?? null,
          FreeQuantity: currentItem?.FreeQuantity ?? null,
          Discount: value,
          NetPrice: currentItem?.NetPrice ?? 0,
        }),
      );
    }
  } else {
    // Handle null or invalid values
    if (field === "Quantity") {
      store.dispatch(
        updateOfferItemDetails({
          Id: row.Id,
          Quantity: null, // Set Quantity to null if invalid
          FreeQuantity: currentItem?.FreeQuantity ?? null, // Keep FreeQuantity unchanged
          Discount: currentItem?.Discount ?? null, // Keep Discount unchanged
          NetPrice: currentItem?.NetPrice ?? 0,
        }),
      );
    }

    if (field === "FreeQuantity") {
      store.dispatch(
        updateOfferItemDetails({
          Id: row.Id,
          Quantity: currentItem?.Quantity ?? null, // Keep Quantity unchanged
          FreeQuantity: null, // Set FreeQuantity to null if invalid
          Discount: currentItem?.Discount ?? null, // Keep Discount unchanged
          NetPrice: currentItem?.NetPrice ?? 0,
        }),
      );
    }

    if (field === "Discount") {
      store.dispatch(
        updateOfferItemDetails({
          Id: row.Id,
          Quantity: currentItem?.Quantity ?? null, // Keep Quantity unchanged
          FreeQuantity: currentItem?.FreeQuantity ?? null, // Keep FreeQuantity unchanged
          Discount: null, // Set Discount to null if invalid
          NetPrice: currentItem?.NetPrice ?? 0,
        }),
      );
    }

    console.log("Invalid or negative value provided, skipping dispatch.");
  }
};

export const getTranslation = (key: string) => i18next.t(key);

export const timeToMinutes = (time: string) => {
  const [hours, minutes, period] = time?.split(/[:\s]/);
  let totalMinutes = parseInt(hours) * 60 + parseInt(minutes);

  if (period === "PM" && parseInt(hours) !== 12) {
    totalMinutes += 12 * 60; // Adjust for PM times
  }

  if (period === "AM" && parseInt(hours) === 12) {
    totalMinutes -= 12 * 60; // Adjust for 12 AM
  }

  return totalMinutes;
};

export const removeDuplicateShifts = (timeShifts: any) => {
  const uniqueShifts = [];
  const shiftSet = new Set();

  for (const shift of timeShifts) {
    const shiftKey = `${shift.FromTime}-${shift.ToTime}`; // Create a unique key for each shift
    if (!shiftSet.has(shiftKey)) {
      uniqueShifts.push(shift); // Add only unique shifts
      shiftSet.add(shiftKey);
    }
  }

  return uniqueShifts;
};

export const formatTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0",
  )}`;
};
export const getOrderStatusBg = (
  orderStatus: string,
  orderCompletePercentage?: number,
) => {
  return (
    <p
      className={`w-fit rounded-md px-3 py-1 text-xs font-bold capitalize ${
        orderStatus === "Approved"
          ? "bg-primaryLighter text-primaryMain"
          : orderStatus === OrderStatusEnum.REJECTED
            ? "bg-errorLighter text-errorMain"
            : orderStatus === OrderStatusEnum.PENDING
              ? "bg-warningLighter text-warningMain"
              : orderStatus === OrderStatusEnum.ACCEPTED
                ? "bg-primaryLighter text-primaryMain"
                : orderStatus?.includes("Accepted Partially")
                  ? "bg-primaryLighter text-primaryMain"
                  : orderStatus === OrderStatusEnum.ACCEPTEDPARTIALLY
                    ? "bg-primaryLighter text-primaryMain"
                    : orderStatus === OrderStatusEnum.CANCELED
                      ? "bg-gray-100 text-gray-800"
                      : orderStatus === OrderStatusEnum.EXPIRED
                        ? "bg-defaultBg text-textColor"
                        : "bg-primaryLighter text-primaryMain"
      }`}
    >
      {orderStatus === OrderStatusEnum.ACCEPTEDPARTIALLY &&
      orderCompletePercentage !== undefined
        ? `${i18next.t(`${orderStatus}`)} (${orderCompletePercentage}%)`
        : i18next.t(`${orderStatus}`)}
    </p>
  );
};
export const getOfferTypeBg = (offerType: string) => {
  const offerTypeTranslation = i18next.t(offerType);
  return (
    <p
      className={`w-fit rounded-md px-3 py-1 text-sm font-semibold capitalize ${
        offerType === OfferTypesEnum.Quantity ||
        offerType === OfferTypesEnum.PackageQuantity
          ? "bg-warningLighter text-warningMain"
          : offerType === OfferTypesEnum.PackageNormal ||
              offerType === OfferTypesEnum.PackageDiscount
            ? "bg-secondaryLighter text-secondaryMain"
            : offerType === OfferTypesEnum.Discount
              ? "bg-successLighter text-successMain"
              : "bg-defaultBg text-CTA"
      }`}
    >
      {offerTypeTranslation}
    </p>
  );
};
export const getProductStatusBg = (productStatus: string | undefined) => {
  return productStatus === ProductStatusEnum.available
    ? "bg-primaryLighter text-primaryMain"
    : productStatus === ProductStatusEnum.unavailable
      ? "bg-defaultBg text-CTA"
      : productStatus === ProductStatusEnum.hide
        ? "bg-defaultBg text-CTA"
        : "bg-CTA text-black";
};
export const getDrugStatusBg = (drugStatus: string | undefined) => {
  return drugStatus === DrugStatusEnum.available
    ? "bg-primaryLighter text-primaryMain"
    : drugStatus === DrugStatusEnum.unavailable
      ? "bg-defaultBg text-CTA"
      : drugStatus === DrugStatusEnum.hide
        ? "bg-defaultBg text-CTA"
        : "bg-CTA text-black";
};
export const downloadBase64File = (
  base64Data: string | undefined,
  fileName: string,
  mimeType: string,
) => {
  // Check if base64Data is defined and is a string
  if (!base64Data || typeof base64Data !== "string") {
    console.error("Invalid base64 data");
    return;
  }
  // Remove potential prefix from base64 data
  const cleanBase64Data = base64Data.includes(",")
    ? base64Data.split(",")[1]
    : base64Data;

  try {
    // Decode base64 to binary data
    const byteCharacters = atob(cleanBase64Data);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // Create a link element and trigger the download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error decoding base64 data:", error);
  }
};

export const SwipeDateFormat = (date: any) => {
  const [year, month, day] = date.split("-");
  const expirationDateReversed = `${day}-${month}-${year}`;

  return expirationDateReversed;
};

export const encodeSpecialChars = (input: string) => {
  return encodeURIComponent(input);
};

export const formatPrice = (
  amount: number,
  locale: string = i18next.language === ArabicCode ? "ar-SY" : "en-US",
): string => {
  try {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
    }).format(amount);
  } catch (error) {
    console.error("Error formatting price:", error);
    return amount.toString();
  }
};
export const maskPhoneNumber = (phone: string, countryCode: string) => {
  // Check if the first digit is 0 and use the next 3 digits if it is
  const firstThreeDigits = phone.startsWith("0")
    ? phone.slice(1, 4)
    : phone.slice(0, 5);
  const lastDigit = phone.slice(-1); // Last digit
  const maskedPart = phone.slice(0, 5).replace(/\d/g, "*"); // Mask the middle part

  // If the phone number has more than 4 digits, mask the middle part fully
  return `${countryCode}${firstThreeDigits}${maskedPart}${lastDigit}`;
};

export const combinePhoneNumberWithISO = (
  ZipCode: string | null | undefined,
  phoneNumber: string | null | undefined,
): string => {
  // Ensure that the ISO code is formatted correctly with a '+' at the start
  const formattedISO =
    ZipCode && ZipCode.startsWith("+") ? ZipCode : `${ZipCode}`;

  // Remove leading zero from the phone number, if present
  const cleanedPhoneNumber =
    phoneNumber && phoneNumber.startsWith("0")
      ? phoneNumber.slice(1)
      : phoneNumber;

  // Return the combined phone number
  return `${formattedISO}${cleanedPhoneNumber}`;
};
export const RenderCompleteInCompleteFacilityState = (
  tab: any,
  ProfileCurrentFacility: any,
  loadingState: any,
) => {
  if (loadingState) {
    return (
      <div className="flex flex-col items-center justify-center">
        {/* <Loader radius={30} /> */}
      </div>
    );
  }
  switch (tab.title) {
    case ProfileTabsEnum.facilityInfo:
      return ProfileCurrentFacility?.BasicInfoPercentage === 100
        ? i18next.t("completed")
        : i18next.t("incompleted");
    case ProfileTabsEnum.facilityAddress:
      return ProfileCurrentFacility?.AddressPercentage === 100
        ? i18next.t("completed")
        : i18next.t("incompleted");
    case ProfileTabsEnum.contactInfo:
      return ProfileCurrentFacility?.ContactInfoPercentage === 100
        ? i18next.t("completed")
        : i18next.t("incompleted");
    case ProfileTabsEnum.workingTimes:
      return ProfileCurrentFacility?.WorkingTimePercentage === 100
        ? i18next.t("completed")
        : i18next.t("incompleted");
    case ProfileTabsEnum.InsuranceCompanies:
      return ProfileCurrentFacility?.InsurancePercentage === 100
        ? i18next.t("completed")
        : i18next.t("incompleted");
    case ProfileTabsEnum.companies:
      return "";
    default:
      return ProfileCurrentFacility?.BasicInfoPercentage === 100
        ? i18next.t("completed")
        : i18next.t("incompleted");
  }
};
export const RenderCompleteInCompleteFacilityStateColor = (
  tab: any,
  ProfileCurrentFacility: any,
  loadingState: any,
) => {
  if (loadingState) {
    return (
      <div className="flex flex-col items-center justify-center">
        <Loader radius={50} />
      </div>
    );
  }

  switch (tab.title) {
    case ProfileTabsEnum.facilityInfo:
      return ProfileCurrentFacility?.BasicInfoPercentage === 100
        ? "text-textColor"
        : "text-primaryMain";
    case ProfileTabsEnum.facilityAddress:
      return ProfileCurrentFacility?.AddressPercentage === 100
        ? "text-textColor"
        : "text-primaryMain";
    case ProfileTabsEnum.contactInfo:
      return ProfileCurrentFacility?.ContactInfoPercentage === 100
        ? "text-textColor"
        : "text-primaryMain";
    case ProfileTabsEnum.workingTimes:
      return ProfileCurrentFacility?.WorkingTimePercentage === 100
        ? "text-textColor"
        : "text-primaryMain";
    case ProfileTabsEnum.InsuranceCompanies:
      return ProfileCurrentFacility?.InsurancePercentage === 100
        ? "text-textColor"
        : "text-primaryMain";
    default:
      return ProfileCurrentFacility?.BasicInfoPercentage === 100
        ? "text-textColor"
        : "text-primaryMain";
  }
};

export const convertTo24HourFormat = (time: string) => {
  const [hours, minutes, period] = time?.split(/[:\s]/);
  let newHours = parseInt(hours);
  if (period === "PM" && newHours !== 12) {
    newHours += 12; // Convert PM times to 24-hour format
  }
  if (period === "AM" && newHours === 12) {
    newHours = 0; // Handle 12 AM as 00:00 in 24-hour format
  }
  return `${newHours.toString().padStart(2, "0")}:${minutes}`; // Ensure two-digit hour formatting
};

export const reverseDateFormat = (dateString: string) => {
  if (!dateString || typeof dateString !== "string") return "";
  const parts = dateString?.split("-");
  if (parts?.length !== 3) return "";
  const [year, month, day] = parts;
  return `${day}-${month}-${year}`;
};

// Helper function to convert 24-hour time to 12-hour AM/PM format
export const convertTo12HourFormat = (time: string) => {
  // Check if the input is already in 12-hour format (with AM/PM)
  if (time.includes("AM") || time.includes("PM")) {
    return time; // If it's already in 12-hour format, return it as-is
  }

  // Split the time string into hours and minutes
  const [hours, minutes] = time.split(":").map(Number);

  // Determine AM/PM period
  const period = hours >= 12 ? "PM" : "AM";
  const twelveHour = hours % 12 || 12; // Convert hour 0 to 12 for midnight

  // Return the formatted string in 12-hour format
  return `${twelveHour}:${minutes.toString().padStart(2, "0")} ${period}`;
};

export const ProcessProductGalleryImages = (Files: any[]) => {
  let processedFiles: any[] = [];

  Files.forEach((file: any) => {
    if (file.Url && !file.File) {
      //? Case 1: No changes (skip sending this file)
      return;
    } else if (!file.Url && file.Id > 0) {
      //? Case 2: File was deleted
      processedFiles.push({
        Id: file.Id,
        File: null, // Indicate the file was deleted
      });
    } else if (file.Id === 0 && file.File) {
      //? Case 3: File is new (Add case)
      processedFiles.push({
        Id: 0, // New files don't have an ID
        File: file.File,
      });
    } else if (file.Id > 0 && file.File) {
      //? Case 4: File is being updated
      processedFiles.push({
        Id: file.Id,
        File: file.File,
      });
    }
  });

  return processedFiles;
};

export const ClearThoseItemsFromLocalStorageAfterRequestDetailsProcess = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("countdown_timer")) {
      localStorage.removeItem(key);
    }
  });
  Object.keys(sessionStorage).forEach((key) => {
    if (key.startsWith("countdown_timer")) {
      sessionStorage.removeItem(key);
    }
  });
};

export const clearLocalStorageExceptReduxPersist = () => {
  const reduxPersistKey = "persist:root";
  const reduxPersistValue = localStorage.getItem(reduxPersistKey);
  localStorage.clear();
  sessionStorage.clear(); // sessions Storage
  if (reduxPersistValue !== null) {
    localStorage.setItem(reduxPersistKey, reduxPersistValue);
    sessionStorage.setItem(reduxPersistKey, reduxPersistValue); // sessions Storage
  }
};

export const ErrorCodesRedirections = (
  errorCode: number,
  navigateToErrorPageIfThereisError?: boolean,
) => {
  if (errorCode === 404) {
    if (!navigateToErrorPageIfThereisError) {
      console.warn("Skipping 404 redirection as per API flag");
      return;
    }
    window.location.assign("/404");
    return;
  }

  switch (errorCode) {
    case 401:
      if (!navigateToErrorPageIfThereisError) {
        console.warn("Skipping logout & toast due to 401 flag");
        return;
      }
      store.dispatch(
        ToggleShowGeneralToast({
          ToasterContent: {
            title: i18next.t("session_expired"),
            desc: i18next.t("session_expired_desc"),
            duration: GlobalToasterDuration,
            img: ToasterErrorImageUrl,
            position: "bottom-right",
            type: "error",
          },
        }),
      );
      store.dispatch(logout());
      break;

    case 403:
      if (!navigateToErrorPageIfThereisError) {
        console.warn("Skipping logout & toast due to 403 flag");
        return;
      }
      store.dispatch(
        ToggleShowGeneralToast({
          ToasterContent: {
            title: i18next.t("access_denied"),
            desc: i18next.t("access_denied_desc"),
            duration: GlobalToasterDuration,
            img: ToasterErrorImageUrl,
            position: "bottom-right",
            type: "error",
          },
        }),
      );
      store.dispatch(logout());
      break;

    case 500:
      if (!navigateToErrorPageIfThereisError) {
        console.warn("Skipping logout & toast due to 500 flag");
        return;
      }
      store.dispatch(
        ToggleShowGeneralToast({
          ToasterContent: {
            title: i18next.t("server_error"),
            desc: i18next.t("server_error_desc"),
            duration: GlobalToasterDuration,
            img: ToasterErrorImageUrl,
            position: "bottom-right",
            type: "error",
          },
        }),
      );
      window.location.assign("/500");
      break;
    default:
      break;
  }
};

export const downloadBlobFileNew = (blob: Blob, filename: string): void => {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};

export const convertOfferTypeNameToArabic = (offerType: string) => {
  switch (offerType) {
    case "Discount":
      return `خصم`;
    case "Quantity":
      return `كمية`;
    case "packageQuantity":
      return `حزمة عالكمية`;
    case "packageDiscount":
      return `حزمة عالخصم`;
    case "packageNormal":
      return `حزمة عادية`;
    default:
      break;
  }
};

export const convertOfferTypeNameToEnglish = (offerType: string) => {
  switch (offerType) {
    case "Discount":
      return `Discount`;
    case "Quantity":
      return `Quantity`;
    case "packageQuantity":
      return `Package Quantity`;
    case "packageDiscount":
      return `Package Discount`;
    case "packageNormal":
      return `Package Normal`;
    default:
      break;
  }
};

export const testPasswordStrength = (password: string) => {
  const meetsCapitalLetter = /[A-Z]/.test(password);
  const meetsLengthRequirement = password.length >= 8;
  const meetsNumberRequirement = /\d/.test(password);
  const strength = [
    meetsCapitalLetter,
    meetsLengthRequirement,
    meetsNumberRequirement,
  ].filter(Boolean).length;
  return strength;
};

export const clearLocalStorageKeysFromSidebar = () => {
  localStorage.removeItem("orderSelectedStatus");
  localStorage.removeItem("orderSelectedType");
  localStorage.removeItem("selectedOfferTableTabFilter");
  localStorage.removeItem("selectedItems");
  localStorage.removeItem("selectedOfferFilterTab");
  localStorage.removeItem(DefaultPharmacyOffersSearchLocalStorageKey);
};

export const InitialNewWarehouseOffferDispatchers = () => {
  store.dispatch(updateOfferStep("initial"));
  store.dispatch(updateOfferType());
  store.dispatch(clearOfferType());
  store.dispatch(clearTotalPrices());
};

export const AcceptWarehouseOrderDispatchers = () => {
  store.dispatch(handlePreventUserToLeave(false));
  store.dispatch(handleIsPreventUserNavigation(false));
  store.dispatch(handleSetGetStartedActivated(false));
  store.dispatch(handleSetEditRequestTimeOutClicked(false));
  store.dispatch(handleSethasUserEditedOnce(false));
  store.dispatch(handleIsOrderRequestTimerActive(false));
  store.dispatch(handleSetGetStartedActivatedForSpecific(false));
  store.dispatch(handleSetGetStartedActivatedForReturned(false));
  store.dispatch(handleSetTimeoutCount(0));
  store.dispatch(handleGetSelectedOrder(null));
};
export const RejectAllOrderButtonDispatchers = () => {
  store.dispatch(handlePreventUserToLeave(false));
  store.dispatch(handleIsPreventUserNavigation(false));
  store.dispatch(handleSetGetStartedActivated(false));
  store.dispatch(handleSetEditRequestTimeOutClicked(false));
  store.dispatch(handleSethasUserEditedOnce(false));
  store.dispatch(handleIsOrderRequestTimerActive(false));
  store.dispatch(handleSetTimeoutCount(0));
  store.dispatch(handleUpdateSelectedRequestTableItems([]));
  store.dispatch(handleGetSelectedOrder(null));
};
export const InitialDispatchersForSpecificOrder = () => {
  store.dispatch(handleSetGetStartedActivatedForSpecific(true));
  store.dispatch(handleSetTotalPriceForSelectedItems(0));
  store.dispatch(handleUpdateSelectedRequestTableItems([]));
};
export const InitialDispatchersForReturnedOrder = () => {
  store.dispatch(handleSetGetStartedActivatedForReturned(true));
  store.dispatch(handleSetTotalPriceForSelectedItems(0));
  store.dispatch(handleUpdateSelectedRequestTableItems([]));
};
export const LeavingOrderPopupDispatchers = () => {
  store.dispatch(handlePreventUserToLeave(false));
  store.dispatch(handleIsPreventUserNavigation(false));
  store.dispatch(handleSetGetStartedActivated(false));
  store.dispatch(handleSetEditRequestTimeOutClicked(false));
  store.dispatch(handleSethasUserEditedOnce(false));
  store.dispatch(handleIsOrderRequestTimerActive(false));
  store.dispatch(handleSetTotalPriceForSelectedItems(0));
  store.dispatch(handleSetTimeoutCount(0));
  store.dispatch(handleUpdateSelectedRequestTableItems([]));
  store.dispatch(handleGetSelectedOrder(null));
};
export const RequestDetailsBackButtonDispatchers = () => {
  store.dispatch(handlePreventUserToLeave(false));
  store.dispatch(handleIsPreventUserNavigation(false));
  store.dispatch(handleSetGetStartedActivated(false));
  store.dispatch(handleSetEditRequestTimeOutClicked(false));
  store.dispatch(handleSethasUserEditedOnce(false));
  store.dispatch(handleIsOrderRequestTimerActive(false));
  store.dispatch(handleSetTotalPriceForSelectedItems(0));
  store.dispatch(handleSetTimeoutCount(0));
  store.dispatch(handleUpdateSelectedRequestTableItems([]));
  store.dispatch(handleGetSelectedOrder(null));
};

export const RequestDetailsGetStartedButtonDispatchers = () => {
  store.dispatch(handlePreventUserToLeave(true));
  store.dispatch(handleIsPreventUserNavigation(true));
  store.dispatch(handleSetGetStartedActivated(true));
  store.dispatch(handleSetEditRequestTimeOutClicked(false));
  store.dispatch(handleSethasUserEditedOnce(false));
  store.dispatch(handleIsOrderRequestTimerActive(true));
  store.dispatch(handleSetTotalPriceForSelectedItems(0));
  store.dispatch(handleSetTimeoutCount(0));
  store.dispatch(handleUpdateSelectedRequestTableItems([]));
};

export const getTimezoneOffset = () => {
  const date = new Date();
  const offset = date.getTimezoneOffset();
  const hours = Math.floor(Math.abs(offset) / 60);
  const minutes = Math.abs(offset) % 60;

  // Format the time zone offset as +03:00 or -05:00
  const sign = offset > 0 ? "-" : "+";
  const formattedOffset = `${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

  return formattedOffset;
};

export const FetchDataFromTableObject = (
  row: TableRow | undefined,
  key: TableKey,
  LoadingCell?: {
    isLoadingCell: boolean;
    loadingCellIds: string[] | number[] | undefined;
  },
  extraRowPayload?: any,
): any => {
  if (row === undefined) {
    return "";
  }
  let RowValue = row[key.name];

  const styleDirection = getCurrentStyleDirection();
  const noDataMessage =
    styleDirection === "rtl" ? "لا يوجد معلومات" : "No Data";
  switch (key.type) {
    case "string":
      if (row === null) {
        return;
      }
      if (row !== null) {
        if (key.name === "Id") {
          return (
            <span className="font-semibold text-textPrimaryColor">
              #{RowValue}
            </span>
          );
        }
        return (
          <p className="max-w-80 text-wrap break-words text-textPrimaryColor">
            {RowValue
              ? `${
                  RowValue?.toString().length > 50
                    ? `${RowValue?.toString().slice(0, 50)}...`
                    : RowValue?.toString()
                }`
              : "-"}
          </p>
        );
      }
      return noDataMessage;
    case "boolean":
      if (RowValue === null) {
        return "-";
      }
      if (row !== null) {
        return (
          <span className="font-semibold text-textPrimaryColor">
            {i18next.t(RowValue ? "yes" : "no")}
          </span>
        );
      }
      return noDataMessage;
    case "approve":
      if (RowValue === null) {
        return (
          <span className="font-semibold text-textPrimaryColor">
            {i18next.t("under_review")}
          </span>
        );
      }
      if (row !== null) {
        return (
          <span className="font-semibold text-textPrimaryColor">
            {i18next.t(RowValue ? "yes" : "no")}
          </span>
        );
      }
      return noDataMessage;
    case "id":
      if (row === null) {
        return noDataMessage;
      }
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return <p className="font-bold text-textPrimaryColor">{RowValue}</p>;
      }
      return noDataMessage;
    case "staff_name":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p className="max-w-80 text-wrap break-words text-textPrimaryColor">
            {RowValue
              ? `${
                  RowValue?.toString().length > 50
                    ? `${RowValue?.toString().slice(0, 50)}...`
                    : RowValue?.toString()
                }`
              : i18next.t("new_staff")}
          </p>
        );
      }
      return noDataMessage;
    case "object":
      return RowValue != null
        ? FetchDataFromTableObject(RowValue, key.sub_value)
        : noDataMessage;
    case "string_with_extra_text":
      return RowValue != null ? `${RowValue} ${key.extra_text}` : noDataMessage;
    case "product_status_select":
      return RowValue != null ? (
        <ChangeProductStatusTableSelect
          variantEnum={ProductStatusEnum}
          selectedOption={RowValue}
          rowProduct={row}
        />
      ) : (
        noDataMessage
      );
    case "product_name":
      return RowValue != null ? (
        <div className="flex flex-col items-center gap-2 2xl:flex-row">
          <GeneralImage
            loading="lazy"
            src={
              row?.CoverImage ? `${BASE_Images_API_URL}/${row.CoverImage}` : ""
            }
            alt={RowValue}
            className="h-12 w-12 rounded-lg object-cover"
          />
          <div className="flex flex-col">
            <p className="text-sm font-normal text-headingTextColor">
              {RowValue}
            </p>
          </div>
        </div>
      ) : (
        noDataMessage
      );
    case "facility_name":
      return RowValue != null ? (
        <div className="flex items-center gap-4">
          <img
            loading="lazy"
            src={RowValue?.image}
            alt={RowValue?.title}
            className="rounded-lg"
          />
          <div className="flex flex-col">
            <p className="text-sm font-normal text-headingTextColor">
              {RowValue?.title}
            </p>
            <p className="text-sm font-normal text-textColor">
              {RowValue?.city}
            </p>
          </div>
        </div>
      ) : (
        noDataMessage
      );
    case "date":
      return RowValue != null ? (
        <p className="text-ellipsis whitespace-nowrap text-sm text-headingTextColor">
          {convertTimestampToDate(RowValue)}
        </p>
      ) : (
        `-`
      );
    case "price":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <div className="flex items-center gap-2">
            {LoadingCell?.isLoadingCell &&
            Array.isArray(LoadingCell?.loadingCellIds) &&
            (LoadingCell.loadingCellIds as number[]).includes(row?.ParentId) ? (
              <Loader />
            ) : (
              <span className="text-ellipsis whitespace-nowrap text-sm text-headingTextColor">
                {`${formatPrice(RowValue)} ${row?.Currency?.Name || ""}`}
              </span>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "orderId":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        if (row.ParentId === null) {
          return (
            <div className="flex items-center gap-2">
              {row?.IsReady ? (
                <img
                  src={`${BASE_LOCAL_IMAGES_DIR}/${orange_flag_IMG}`}
                  alt="Flag"
                />
              ) : null}
              <span className="font-semibold text-textPrimaryColor">{`#${row.Id}`}</span>
            </div>
          );
        } else {
          return (
            <div className="flex items-center gap-2">
              <span className="font-semibold text-textPrimaryColor">{`#${row.ParentId}`}</span>
              {row?.IsReady ? (
                <img
                  src={`${BASE_LOCAL_IMAGES_DIR}/${orange_flag_IMG}`}
                  alt="Flag"
                />
              ) : null}
            </div>
          );
        }
      }
      return noDataMessage;
    case "pharmacyOrderId":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <span className="font-semibold text-textPrimaryColor">{`#${row.Id}`}</span>
        );
      }
      return noDataMessage;
    case "order_state":
      return RowValue != null ? (
        <p
          className={`w-fit rounded-md p-2.5 text-xs font-semibold capitalize`}
        >
          {getOrderStatusBg(
            RowValue === OrderStatusEnum.ACCEPTEDPARTIALLY
              ? `${i18next.t(`${RowValue}`)} ${row.CompletePercentage}%`
              : RowValue,
          )}
        </p>
      ) : (
        noDataMessage
      );
    case "offer_content_name":
      return RowValue != null ? (
        <div className="flex items-center">
          <GeneralImage
            loading="lazy"
            src={
              row?.CoverImage
                ? `${BASE_Images_API_URL}/${row?.CoverImage}`
                : `${BASE_Images_API_URL}/${row?.Image}`
            }
            alt="Offer_IMG"
            className="w-16"
          />
          <div className="flex flex-col">
            <p>{row.Name}</p>
            <span></span>
          </div>
        </div>
      ) : (
        noDataMessage
      );
    case "offer_name":
      let images = row?.Items?.map((item: IOfferItem) => {
        return item.Package !== null
          ? item.Package.Image
          : item.Product.CoverImage;
      });
      return RowValue != null ? (
        <div className="flex items-center gap-4">
          {images !== undefined && images.length === 1 ? (
            <div className="h-12 w-12 overflow-hidden rounded-xl">
              <GeneralImage
                loading="lazy"
                src={
                  images[0] !== "" ? `${BASE_Images_API_URL}/${images[0]}` : ""
                }
                alt="Cover"
                className="h-full w-12 object-cover"
              />
            </div>
          ) : (
            <div className="grid h-12 w-12 grid-cols-2 grid-rows-2 rounded-xl">
              {images?.slice(0, 4).map((img: string, index: number) => {
                if (index === 3 && images.length > 4) {
                  return (
                    <div
                      key={index}
                      className="relative flex items-center justify-center overflow-hidden"
                    >
                      <GeneralImage
                        loading="lazy"
                        src={
                          img && img !== ""
                            ? `${BASE_Images_API_URL}/${img}`
                            : ""
                        }
                        alt={`-${index}`}
                        className="h-full w-12 object-cover"
                      />
                    </div>
                  );
                }
                return (
                  <div className="overflow-hidden" key={index}>
                    <GeneralImage
                      loading="lazy"
                      src={
                        img && img !== "" ? `${BASE_Images_API_URL}/${img}` : ""
                      }
                      alt={`offer_image_${index}`}
                      className="h-full w-12 object-cover"
                    />
                  </div>
                );
              })}
            </div>
          )}
          <p>{`${row.Name}`}</p>
        </div>
      ) : (
        noDataMessage
      );
    case "offer_type":
      return RowValue != null ? (
        <p
          className={`w-fit rounded-md px-3 py-1 text-xs font-semibold capitalize 2xl:text-sm`}
        >
          {getOfferTypeBg(RowValue)}
        </p>
      ) : (
        noDataMessage
      );
    case "request_name":
      return RowValue != null ? (
        <div className="flex items-center gap-4">
          <img
            loading="lazy"
            src={RowValue?.image}
            alt={RowValue?.name}
            className="rounded-lg"
          />
          <div className="flex flex-col">
            <p className="text-sm font-normal text-headingTextColor">
              {RowValue?.name}
            </p>
            <p className="text-sm font-normal text-textColor">
              {RowValue?.location}
            </p>
          </div>
        </div>
      ) : (
        noDataMessage
      );
    case "warehouse_name":
      return RowValue != null ? (
        <div className="flex items-center gap-4">
          <img
            loading="lazy"
            src={RowValue?.image}
            alt={RowValue?.title}
            className="h-10 w-10 rounded-lg"
          />
          <div className="flex flex-col">
            <p className="text-sm font-normal text-headingTextColor">
              {RowValue?.title}
            </p>
          </div>
        </div>
      ) : (
        noDataMessage
      );
    case "orderState":
      return RowValue != null ? (
        <div
          className={`flex items-center gap-4 ${
            RowValue.state === "pending" ? "text-primaryMain" : ""
          }`}
        >
          {RowValue}
        </div>
      ) : (
        noDataMessage
      );
    case "drug_name":
      return RowValue != null ? (
        <div className="flex items-center gap-2">
          <GeneralImage
            loading="lazy"
            src={
              row.Image
                ? `${BASE_Images_API_URL}/${row.Image}`
                : `${BASE_LOCAL_IMAGES_DIR}/${drugs_IMG}`
            }
            alt={RowValue}
            className="h-12 w-12 rounded-lg object-cover"
          />
          <div className="flex flex-col">
            <p className="text-sm font-normal text-headingTextColor">
              {RowValue}
            </p>
            <a
              href="#"
              data-tooltip-id="scientificName-tooltip"
              data-tooltip-content={row?.ScientificName}
            >
              <p className="text-sm font-normal text-textColor">
                {row?.ScientificName?.slice(0, 20)}...
              </p>
            </a>
            <Tooltip
              id="scientificName-tooltip"
              className="z-50 max-w-xl break-words break-all"
            />
          </div>
        </div>
      ) : (
        noDataMessage
      );
    case "drug_status_select":
      return RowValue != null ? (
        <ChangeDrugStatusTableSelect
          variantEnum={DrugStatusEnum}
          selectedOption={RowValue}
          rowDrug={row}
        />
      ) : (
        noDataMessage
      );
    case "drug_brand_name":
      return RowValue !== null ? (
        <span>{row?.Facility?.Name}</span>
      ) : (
        noDataMessage
      );
    case "offerExpirationDate":
      if (row === null) {
        return noDataMessage;
      }

      if (row !== null) {
        const offerDate = new Date(convertTimestampToDate(RowValue));
        const currentDate = new Date();
        if (offerDate < currentDate) {
          return (
            <p className="text-ellipsis whitespace-nowrap text-sm text-textPrimaryColor">
              {i18next.t("time_is_end")}
            </p>
          );
        }

        return (
          <p className="text-ellipsis whitespace-nowrap text-sm text-headingTextColor">
            {convertTimestampToDate(RowValue)}
          </p>
        );
      }

      return noDataMessage;
    //?============================= Offer Discount Types========================
    case "DiscountOfferName":
      return row !== null && row.Package === null ? (
        <div className="flex items-center gap-2">
          <GeneralImage
            loading="lazy"
            src={
              row?.Product
                ? `${BASE_Images_API_URL}/${row?.Product?.CoverImage}`
                : ""
            }
            alt="Offer_IMG"
            className="h-12 w-12 rounded-lg object-cover"
          />
          <div className="flex flex-col">
            <p className="text-sm font-normal text-headingTextColor">
              {row?.Product?.Name}
            </p>
          </div>
        </div>
      ) : row.Package !== null && row.Product === null ? (
        <div className="flex items-center gap-2">
          <GeneralImage
            loading="lazy"
            src={
              row?.Package
                ? `${BASE_Images_API_URL}/${row?.Package?.Image}`
                : ""
            }
            alt="Offer_IMG"
            className="mx-2 h-12 w-12 rounded-lg object-cover"
          />
          <div className="flex flex-col gap-2">
            <p className="text-sm font-normal text-headingTextColor">
              {row?.Package?.Name}
            </p>
          </div>
        </div>
      ) : (
        <span>{noDataMessage}</span>
      );
    case "DiscountOfferBrand":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row.Product.BrandName ? row.Product.BrandName : noDataMessage}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Package?.Facility?.Name
              ? row?.Package?.Facility?.Name
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "DiscountOfferQuantity":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row.Quantity ? row.Quantity : noDataMessage}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Quantity ? row?.Quantity : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "DiscountOfferNetPrice":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Product?.NetPrice
              ? `${formatPrice(row?.Product?.NetPrice)} ${
                  row?.Product?.Currency.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Package?.NetPrice
              ? `${formatPrice(row?.Package?.NetPrice)} ${
                  row?.Package?.Currency.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "DiscountOfferSellingPrice":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Product?.SellingPrice
              ? `${formatPrice(row?.Product?.SellingPrice)} ${
                  row?.Product?.Currency.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Package?.SellingPrice
              ? `${formatPrice(row?.Package?.SellingPrice)} ${
                  row?.Package?.Currency?.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "DiscountOfferPrice":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <div className="flex flex-col rounded-lg px-2 py-1.5">
            <p className="text-xs font-semibold text-bodyTextColor line-through">
              {formatPrice(row?.Price)}
            </p>
            <p className="text-xs font-semibold text-textPrimaryColor">
              {`${formatPrice(
                row?.PriceAfterDiscount,
              )} ${i18next.t("per_piece")}`}
            </p>
          </div>
        );
      }
      return noDataMessage;
    //?============================= Offer Quantity Types========================
    case "QuantityOfferName":
      return row !== null && row.Package === null ? (
        <div className="flex items-center gap-2">
          <GeneralImage
            loading="lazy"
            src={
              row?.Product
                ? `${BASE_Images_API_URL}/${row?.Product?.CoverImage}`
                : ""
            }
            alt="Offer_IMG"
            className="h-10 w-10 rounded-lg"
          />
          <div className="flex flex-col">
            <p className="text-ellipsis text-sm font-normal text-headingTextColor">
              {row?.Product?.Name}
            </p>
          </div>
        </div>
      ) : row.Package !== null && row.Product === null ? (
        <div className="flex items-center gap-2">
          <GeneralImage
            loading="lazy"
            src={
              row?.Package
                ? `${BASE_Images_API_URL}/${row?.Package?.Image}`
                : ""
            }
            alt="Offer_IMG"
            className="mx-2 h-12 w-12 rounded-lg object-cover"
          />
          <div className="flex flex-col">
            <p className="text-ellipsis text-sm font-normal text-headingTextColor">
              {row?.Package?.Name}
            </p>
            <a
              href="#"
              data-tooltip-id="scientificName-tooltip"
              data-tooltip-content={row?.Package?.ScientificName}
            >
              <p className="text-sm font-normal text-headingTextColor">
                {row?.Package?.ScientificName.toString().slice(0, 25)}
              </p>
            </a>

            <Tooltip
              id="scientificName-tooltip"
              className="z-50 max-w-xl break-words break-all"
            />
          </div>
        </div>
      ) : (
        <span>{noDataMessage}</span>
      );
    case "QuantityOfferBrand":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Product.BrandName ? row.Product.BrandName : noDataMessage}
          </p>
        );
      }
      if (row?.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Package?.Facility.Name
              ? row?.Package?.Facility.Name
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "QuantityOfferQuantity":
      if (row === null) {
        return 0;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row.Quantity ? row.Quantity : 0}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Quantity ? row?.Quantity : 0}
          </p>
        );
      }
      return 0;
    case "QuantityOfferFreeQuantity":
      if (row === null) {
        return 0;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="w-fit text-ellipsis rounded-lg bg-secondaryLighter px-2 py-0.5 text-sm font-semibold text-secondaryMain">
            {`+${row.FreeQuantity ? row.FreeQuantity : 0} ${i18next.t("free")}`}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="h-full w-fit text-ellipsis rounded-lg bg-secondaryLighter px-2 py-0.5 text-sm font-semibold text-secondaryMain">
            {`+${row?.FreeQuantity ? row?.FreeQuantity : 0} ${i18next.t("free")}`}
          </p>
        );
      }
      return 0;
    case "QuantityOfferNetPrice":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Product?.NetPrice
              ? `${formatPrice(row?.Product?.NetPrice)} ${
                  row?.Product?.Currency?.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Package?.NetPrice
              ? `${formatPrice(row?.Package?.NetPrice)} ${
                  row?.Package?.Currency?.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "QuantityOfferSellingPrice":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Product?.SellingPrice
              ? `${formatPrice(row?.Product?.SellingPrice)} ${
                  row?.Product?.Currency?.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Package?.SellingPrice
              ? `${formatPrice(row?.Package?.SellingPrice)} ${
                  row?.Package?.Currency?.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "QuantityOfferPrice":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        if (row?.DiscountValue === null) {
          return (
            <p className="text-ellipsis text-sm font-bold text-bodyTextColor">
              {row?.Price
                ? `${formatPrice(row?.Price * row?.Quantity)} ${
                    row?.Currency?.Name
                  }`
                : noDataMessage}
            </p>
          );
        } else {
          return (
            <div className="flex flex-col rounded-lg px-2 py-1.5">
              <p className="text-xs font-semibold text-bodyTextColor line-through">
                {formatPrice(row?.Price * row?.Quantity)}
              </p>
              <p className="text-xs font-semibold text-textPrimaryColor">
                {`${formatPrice(
                  row?.PriceAfterDiscount * row?.Quantity,
                )} ${i18next.t("per_piece")}`}
              </p>
            </div>
          );
        }
      }
      return noDataMessage;
    //?============================= Offer Package Types========================
    case "PackageOfferName":
      return row !== null && row.Package === null ? (
        <div className="flex min-w-[15rem] flex-col items-center lg:flex-row">
          <GeneralImage
            loading="lazy"
            src={
              row?.Product
                ? `${BASE_Images_API_URL}/${row?.Product?.CoverImage}`
                : ""
            }
            alt="Offer_IMG"
            className="mx-2 h-10 w-10 rounded-lg object-cover"
          />
          <div className="flex flex-col">
            <p className="text-sm font-normal text-headingTextColor">
              {row?.Product?.Name.toString().length > 50
                ? `${row?.Product?.Name.slice(0, 50)}...`
                : row?.Product?.Name}
            </p>
          </div>
        </div>
      ) : row.Package !== null && row.Product === null ? (
        <div className="flex flex-col items-center gap-2 lg:flex-row">
          <GeneralImage
            loading="lazy"
            src={
              row?.Package
                ? `${BASE_Images_API_URL}/${row?.Package?.Image}`
                : ""
            }
            alt="Offer_IMG"
            className="h-12 w-12 rounded-lg object-cover"
          />
          <div className="flex flex-col">
            <p className="text-ellipsis text-sm font-normal text-headingTextColor">
              {row?.Package?.Name.toString().length > 50
                ? row?.Package?.Name.slice(0, 50)
                : row?.Package?.Name}
            </p>
            <a
              href="#"
              data-tooltip-id="scientificName-tooltip"
              data-tooltip-content={row?.Package?.ScientificName}
            >
              <p className="text-ellipsis text-sm font-normal text-textColor">
                {row?.Package?.ScientificName.toString().length > 50
                  ? `${row?.Package?.ScientificName.slice(0, 50)}...`
                  : row?.Package?.ScientificName}
              </p>
            </a>
            <Tooltip
              id="scientificName-tooltip"
              className="z-50 max-w-xl break-words break-all"
            />
          </div>
        </div>
      ) : (
        <span>{noDataMessage}</span>
      );
    case "PackageOfferBrand":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row.Product.BrandName ? row.Product.BrandName : noDataMessage}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Package?.Facility?.Name
              ? row?.Package?.Facility?.Name
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "PackageOfferQuantity":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row.Quantity > 0
              ? row.Quantity
              : row.FreeQuantity > 0
                ? row.FreeQuantity
                : noDataMessage}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Quantity
              ? row?.Quantity
              : row.FreeQuantity > 0
                ? row.FreeQuantity
                : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "PackageOfferNetPrice":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Product?.NetPrice
              ? `${formatPrice(row?.Product?.NetPrice)} ${
                  row?.Product?.Currency?.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      if (row?.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Package?.NetPrice
              ? `${formatPrice(row?.Package?.NetPrice)} ${
                  row?.Package?.Currency?.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "PackageOfferSellingPrice":
      if (row === null) {
        return noDataMessage;
      }
      if (row.Package === null && row.Product !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Product?.SellingPrice
              ? `${formatPrice(row?.Product?.SellingPrice)} ${
                  row?.Product?.Currency?.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      if (row.Package !== null && row.Product === null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {row?.Package?.SellingPrice
              ? `${formatPrice(row?.Package?.SellingPrice)} ${
                  row?.Package?.Currency?.Name
                }`
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "PackageOfferPrice":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        if (row?.DiscountValue === null) {
          return (
            <p className="text-ellipsis text-sm font-bold text-bodyTextColor">
              {row?.Price
                ? `${formatPrice(row?.Price * row?.Quantity)} ${
                    row?.Currency?.Name
                  }`
                : noDataMessage}
            </p>
          );
        } else {
          return (
            <div className="flex flex-col rounded-lg px-2 py-1.5">
              <p className="text-xs font-semibold text-bodyTextColor line-through">
                {formatPrice(row?.Price)}
              </p>
              <p className="text-xs font-semibold text-textPrimaryColor">
                {`${formatPrice(
                  row?.PriceAfterDiscount,
                )} ${i18next.t("per_piece")}`}
              </p>
            </div>
          );
        }
      }
      return noDataMessage;
    case "PackageOfferDiscountPercentage":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        if (row?.DiscountValue > 0) {
          return (
            <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
              {`${row?.DiscountValue}%`}
            </p>
          );
        } else {
          return (
            <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
              {i18next.t("no_discount_value")}
            </p>
          );
        }
      }
      return noDataMessage;
    //?============================= Offer Items========================
    case "offer_item_name":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <div className="flex min-w-[14rem] flex-col items-center gap-2 lg:flex-row">
            <GeneralImage
              loading="lazy"
              src={row.Image ? `${BASE_Images_API_URL}/${row.Image}` : ""}
              alt="Offer_Image"
              className="h-14 w-14 rounded-xl object-cover"
            />
            {row.IsDrug ? (
              <div className="flex flex-col">
                <p className="text-wrap text-sm font-normal text-headingTextColor">
                  {row?.Name.toString().slice(0, 50)}
                </p>
                <a
                  data-tooltip-id="scientificName-tooltip"
                  data-tooltip-content={row?.ScientificName}
                >
                  <span className="text-wrap text-sm font-normal text-headingTextColor">
                    {row?.ScientificName?.toString()?.slice(0, 50)}...
                  </span>
                </a>
                <Tooltip
                  id="scientificName-tooltip"
                  className="z-50 max-w-xl break-words break-all"
                />
              </div>
            ) : (
              <>
                {row?.Name.toString().length > 30 ? (
                  <>
                    {" "}
                    <a
                      href="#"
                      data-tooltip-id="scientificName-tooltip"
                      data-tooltip-content={row?.Name}
                      data-tooltip-place="bottom"
                    >
                      <p className="text-wrap text-sm font-normal text-headingTextColor">
                        {row?.Name.toString().slice(0, 30)}
                      </p>
                    </a>
                    <Tooltip
                      id="scientificName-tooltip"
                      className="z-50 max-w-xl break-words break-all"
                    />
                  </>
                ) : (
                  <span className="">{row?.Name}</span>
                )}
              </>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "offer_item_brandname":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <div>
            <p className="text-wrap text-bodyTextColor">
              {row?.IsDrug ? row?.Facility?.Name : row?.BrandName}
            </p>
          </div>
        );
      }
      return noDataMessage;
    case "offersChooseQuantityItemQuantity":
      if (row === null) {
        return noDataMessage;
      }

      const item = (
        store.getState() as unknown as RootState
      ).offer.offerItems.find(
        (item) => item !== undefined && item.Id === row.Id,
      );

      if (item) {
        return (
          <div>
            <input
              type="text"
              className="w-full min-w-[15rem] rounded-xl bg-inputBg p-4 shadow-none outline-none"
              placeholder={i18next.t("quantity")}
              value={
                item.Quantity !== null && item.Quantity !== undefined
                  ? String(item.Quantity)
                  : ""
              }
              maxLength={6}
              onChange={(e) => {
                const value = e.target.value;
                const validValue = /^[0-9]*$/.test(value)
                  ? parseFloat(value)
                  : null;
                if (value === "") {
                  handleOfferItemChange(row, "Quantity", null);
                } else if (validValue !== null && validValue >= 0) {
                  handleOfferItemChange(row, "Quantity", validValue);
                }
                store.dispatch(updateOfferType());
              }}
            />
          </div>
        );
      }

      return noDataMessage;
    case "offersChooseQuantityFreeQuantity":
      const disableFreeQuantityForAll = (
        store.getState() as unknown as RootState
      ).offer.disableFreeQuantityForAll;
      const freeQuantityItem = (
        store.getState() as unknown as RootState
      ).offer.offerItems.find((item) => item.Id === row.Id);

      if (freeQuantityItem) {
        return (
          <div>
            <input
              type="text"
              className="w-full min-w-[15rem] rounded-xl bg-inputBg p-4 shadow-none outline-none"
              value={
                freeQuantityItem.FreeQuantity !== null &&
                freeQuantityItem.FreeQuantity !== undefined
                  ? String(freeQuantityItem.FreeQuantity)
                  : "" // Show empty string when the value is null or undefined
              }
              placeholder={i18next.t("quantity")}
              disabled={disableFreeQuantityForAll}
              maxLength={6}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                  handleOfferItemChange(row, "FreeQuantity", null); // Allow null for empty input
                } else {
                  const validValue = /^[0-9]*$/.test(value)
                    ? parseFloat(value)
                    : null;
                  if (validValue !== null && validValue >= 0) {
                    handleOfferItemChange(row, "FreeQuantity", validValue);
                  }
                }
                store.dispatch(updateOfferType());
              }}
            />
          </div>
        );
      }

      return noDataMessage;
    case "offersChooseQuantityDiscount":
      const disableDiscountForAll = (store.getState() as unknown as RootState)
        .offer.disableDiscountForAll;
      const discountItem = (
        store.getState() as unknown as RootState
      ).offer.offerItems.find((item) => item.Id === row.Id);

      if (discountItem) {
        return (
          <div className="relative">
            <input
              type="text"
              className="w-full min-w-[15rem] rounded-xl bg-inputBg p-4 shadow-none outline-none"
              placeholder={i18next.t("percentage_offer")}
              value={
                discountItem.Discount !== null &&
                discountItem.Discount !== undefined
                  ? String(discountItem.Discount)
                  : //? Show empty string when the value is null or undefined
                    ""
              }
              disabled={disableDiscountForAll || !discountItem.Quantity}
              maxLength={6}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                  //? Allow null for empty input
                  handleOfferItemChange(row, "Discount", null);
                } else {
                  const validValue = /^[0-9]*$/.test(value)
                    ? parseFloat(value)
                    : null;
                  if (validValue !== null && validValue >= 0) {
                    const boundedValue = Math.min(Math.max(validValue, 0), 100);
                    handleOfferItemChange(row, "Discount", boundedValue);
                  }
                }
                store.dispatch(updateOfferType());
              }}
            />
            {discountItem.Discount && (
              <img
                loading="lazy"
                src={`${BASE_LOCAL_IMAGES_DIR}/${percentage_sign_IMG}`}
                alt="percentage_sign"
                className={`absolute top-6 ${
                  i18next.language === ArabicCode ? "left-12" : "right-12"
                }`}
              />
            )}
          </div>
        );
      }

      return noDataMessage;
    case "offersChooseQuantityDiscountPrice":
      if (row === null) {
        //? Return no data message if row is null
        return noDataMessage;
      }
      // const currentItems = store.getState().offer.offerItems;
      // const OfferItem = currentItems.find((item) => item?.Id === row?.Id);

      const currentItems = (store.getState() as unknown as RootState).offer
        .offerItems;
      const OfferItem = currentItems.find((item) => item?.Id === row?.Id);

      if (!OfferItem || OfferItem.Quantity === null) {
        //? Return no data message if OfferItem is not found or Quantity is null
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {`0 ${
              OfferItem?.Currency
                ? OfferItem?.Currency?.Name
                : i18next.language.slice(0, 2) === ArabicCode
                  ? GlobalSyrianCurrentLabelAr
                  : GlobalSyrianCurrentLabelEn
            } `}
          </p>
        );
      }
      //? Calculate the total price based on the discount percentage
      const totalPrice =
        OfferItem.Discount == null || OfferItem.Discount === 0
          ? OfferItem.NetPrice * OfferItem.Quantity
          : OfferItem.NetPrice *
            OfferItem.Quantity *
            (1 - OfferItem.Discount / 100);

      return (
        <div className="max-w-20 flex-wrap text-wrap">
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor">
            {totalPrice
              ? `${formatPrice(totalPrice)} ${
                  OfferItem?.Currency
                    ? OfferItem?.Currency?.Name
                    : i18next.language.slice(0, 2) === ArabicCode
                      ? GlobalSyrianCurrentLabelAr
                      : GlobalSyrianCurrentLabelEn
                } `
              : `0 ${
                  OfferItem?.Currency
                    ? OfferItem?.Currency?.Name
                    : i18next.language.slice(0, 2) === ArabicCode
                      ? GlobalSyrianCurrentLabelAr
                      : GlobalSyrianCurrentLabelEn
                } `}
          </p>
        </div>
      );
    //?============================= Order Types========================
    case "order_warehouse_name":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div className="flex flex-wrap items-center gap-2">
            <div className="relative">
              <GeneralImage
                loading="lazy"
                src={
                  row?.ToFacility?.Image !== null
                    ? `${BASE_Images_API_URL}/${row?.ToFacility?.Image}`
                    : ""
                }
                alt="warehouse_img"
                className="mx-2 h-10 w-10 rounded-lg object-cover 2xl:h-12 2xl:w-12"
              />
              {row.Type === OrderTypesEnum.ALL ? (
                <img
                  loading="lazy"
                  src={`${BASE_LOCAL_IMAGES_DIR}/${star_IMG}`}
                  alt="star"
                  className={`h-3 w-3 ${
                    i18next.language.slice(0, 2) === ArabicCode
                      ? "absolute -bottom-1 right-6"
                      : "absolute -bottom-1 left-[26px]"
                  }`}
                />
              ) : null}
            </div>
            <div className="flex flex-col flex-wrap">
              {row.Type === OrderTypesEnum.RETURNED ? (
                <p className="flex items-center gap-2 text-wrap text-sm font-normal capitalize text-errorMain">
                  <FaArrowRotateLeft className="text-errorMain" />
                  <span className="cursor-pointer">
                    <a
                      data-tooltip-id="pharmacy-name-tooltip"
                      data-tooltip-content={"Returned Order"}
                    >
                      {row?.ToFacility ? row?.ToFacility?.Name : noDataMessage}
                    </a>
                    <Tooltip
                      id="pharmacy-name-tooltip"
                      className="z-50 max-w-xl break-words break-all !bg-errorMain"
                    />
                  </span>
                </p>
              ) : (
                <p className="text-wrap text-sm font-normal capitalize text-headingTextColor">
                  {row?.ToFacility ? row?.ToFacility?.Name : noDataMessage}
                </p>
              )}
              <p className="text-sm font-normal capitalize text-textColor">
                {row?.ToFacility?.City?.Name}
              </p>
            </div>
          </div>
        );
      }
      return noDataMessage;
    case "patient_order_pharmacy_name":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div className="flex items-center gap-2">
            <GeneralImage
              loading="lazy"
              src={`${BASE_Images_API_URL}/${row?.Image}`}
              alt="warehouse_img"
              className="h-14 w-14 rounded-lg object-cover"
            />
            <div className="flex items-center gap-2">
              {row?.Status === OrderStatusEnum.PENDING ? (
                <div className="flex items-center gap-1">
                  <img
                    src={`${BASE_LOCAL_IMAGES_DIR}/${incoming_order_orange_arrow_IMG}`}
                    alt="outgoing_aqua_arrow"
                  />
                  <span className="font-semibold text-textPrimaryColor">{`#${row.Id}`}</span>
                </div>
              ) : (
                <div className="flex items-center gap-1">
                  <img
                    src={`${BASE_LOCAL_IMAGES_DIR}/${incoming_order_blue_arrow_IMG}`}
                    alt="incoming_order_blue_arrow"
                  />
                  <span className="font-semibold text-textPrimaryColor">{`#${row.Id}`}</span>
                </div>
              )}
            </div>
          </div>
        );
      }
      return noDataMessage;
    case "order_pharmacy_name":
      if (row === null) {
        return;
      }
      if (row !== null) {
        switch (row.Type) {
          //!=== All Case ===
          case OrderTypesEnum.ALL:
            return (
              <div className="flex items-center gap-2">
                <div className="rounded-xl bg-warningLight p-2.5">
                  <img
                    loading="lazy"
                    src={`${BASE_LOCAL_IMAGES_DIR}/${all_warehouses_star_IMG}`}
                    alt="warehouse_img"
                    className="h-6 w-6 rounded object-cover"
                  />
                </div>
                <p className="text-sm font-normal capitalize text-headingTextColor">
                  {i18next.t("all_warehouses")}
                </p>
              </div>
            );
          case OrderTypesEnum.SPECIFIC:
            return (
              <div className="flex items-center gap-2">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.FromFacility?.Image !== null
                      ? `${BASE_Images_API_URL}/${row?.FromFacility?.Image}`
                      : ""
                  }
                  alt="warehouse_img"
                  className="h-14 w-14 rounded-lg object-cover"
                />
                <p className="text-sm font-normal capitalize text-headingTextColor">
                  {row?.FromFacility?.Name}
                </p>
              </div>
            );
          case OrderTypesEnum.RETURNED:
            return (
              <div className="flex items-center gap-2">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.FromFacility?.Image !== null
                      ? `${BASE_Images_API_URL}/${row?.FromFacility?.Image}`
                      : ""
                  }
                  alt="warehouse_img"
                  className="h-14 w-14 rounded-lg object-cover"
                />
                <div className="flex flex-col">
                  <p className="text-sm font-normal capitalize text-headingTextColor">
                    {row?.FromFacility?.Name}
                  </p>
                  <p className="text-xs font-normal capitalize text-errorMain">
                    {i18next.t("returned_order")}
                  </p>
                </div>
              </div>
            );
        }
      }
      return noDataMessage;
    case "order_warehouse_date":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div className="flex items-center gap-1">
            <span className="text-textPrimaryColor">
              {convertTimestampToDate(row?.FromDate)}
            </span>
            <span className="block h-1 w-1 rounded-full bg-textPrimaryColor"></span>
            <span className="text-textPrimaryColor">
              {convertTimestampToDate(row?.ToDate)}
            </span>
          </div>
        );
      }
      return noDataMessage;
    case "OrderInvoiceName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        let images = row?.Offer?.Items?.map((OfferItem: IOfferItem) => {
          return OfferItem.Package !== null
            ? OfferItem.Package.Image
            : OfferItem.Product.CoverImage;
        });
        return (
          <div>
            {row?.Package !== null ? (
              <div className="flex items-center gap-2">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Package?.Image
                      ? `${BASE_Images_API_URL}/${row?.Package?.Image}`
                      : ""
                  }
                  alt="Drug_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <p className="text-sm text-bodyTextColor">
                  {row?.Package?.Name}
                </p>
              </div>
            ) : row?.Offer !== null ? (
              <div className="flex items-center gap-2">
                {images !== undefined && images.length === 1 ? (
                  <div className="h-16 w-16 overflow-hidden rounded-xl">
                    <GeneralImage
                      loading="lazy"
                      src={
                        images[0] !== ""
                          ? `${BASE_Images_API_URL}/${images[0]}`
                          : ""
                      }
                      alt="Offer_image"
                      className="h-16 min-h-16 w-16 min-w-16 rounded-xl object-cover"
                    />
                  </div>
                ) : (
                  <div className="grid h-16 w-16 grid-cols-2 grid-rows-2 rounded-xl">
                    {images?.slice(0, 4).map((img: string, index: number) => {
                      if (index === 3 && images.length > 4) {
                        return (
                          <div
                            key={index}
                            className="relative flex items-center justify-center overflow-hidden"
                          >
                            <GeneralImage
                              loading="lazy"
                              src={
                                img && img !== ""
                                  ? `${BASE_Images_API_URL}/${img}`
                                  : ""
                              }
                              alt={`-${index}`}
                              className="h-7 w-7 rounded-xl object-cover"
                            />
                          </div>
                        );
                      }
                      return (
                        <div className="rounded-xl" key={index}>
                          <GeneralImage
                            loading="lazy"
                            src={
                              img && img !== ""
                                ? `${BASE_Images_API_URL}/${img}`
                                : ""
                            }
                            alt={`-${index}`}
                            className="h-6 w-6 rounded-xl object-cover"
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                <p className="text-sm text-bodyTextColor">{row?.Offer?.Name}</p>
              </div>
            ) : row?.Product !== null ? (
              <div className="flex items-center gap-2">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Product?.CoverImage
                      ? `${BASE_Images_API_URL}/${row?.Product?.CoverImage}`
                      : ""
                  }
                  alt="Product_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <p className="text-sm text-bodyTextColor">
                  {row?.Product.Name}
                </p>
              </div>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "OrderInvoiceBrandName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Package !== null ? (
              <p className="text-sm text-bodyTextColor">
                {row?.Package?.Facility?.Name ?? noDataMessage}
              </p>
            ) : row?.Offer !== null ? (
              <p className="text-sm text-bodyTextColor">
                {row?.Offer?.Facility?.Name ?? "-"}
              </p>
            ) : row?.Product !== null ? (
              <p className="text-sm text-bodyTextColor">
                {row?.Product?.BrandName ?? noDataMessage}
              </p>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "OrderInvoicePrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Package !== null ? (
              <p className="text-sm text-bodyTextColor">{`${formatPrice(row?.Price)} ${row?.Currency?.Name}`}</p>
            ) : row?.Offer !== null ? (
              <p className="text-sm text-bodyTextColor">{`${formatPrice(row?.Price)} ${row?.Currency?.Name}`}</p>
            ) : row?.Product !== null ? (
              <p className="text-sm text-bodyTextColor">{`${formatPrice(row?.Price)} ${row?.Currency?.Name}`}</p>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "OrderInvoiceQuantity":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p className="text-sm text-bodyTextColor">
            {row?.SelectedQuantity ? row?.SelectedQuantity : row?.Quantity} /{" "}
            {row?.Quantity}
          </p>
        );
      }
      return noDataMessage;
    case "OrderInvoiceTotalPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p className="text-sm text-bodyTextColor">
            {`${formatPrice(
              row?.SelectedQuantity > 0
                ? row?.Price * row?.SelectedQuantity
                : row?.Price * row?.Quantity,
            )} ${row?.Currency?.Name}`}
          </p>
        );
      }
      return noDataMessage;
    case "pharmacyMyOrderId":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <div className="flex items-center gap-2">
            {/* <img
              src={`${BASE_LOCAL_IMAGES_DIR}/${outgoing_aqua_arrow_IMG}`}
              alt="outgoing_aqua_arrow"
            /> */}
            <span className="font-semibold text-textPrimaryColor">{`#${row?.ParentId ? row?.ParentId : row.Id}`}</span>
          </div>
        );
      }
      return noDataMessage;
    case "pharmacyPatientOrderId":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <div className="flex items-center gap-2">
            {row?.Status === OrderStatusEnum.PENDING ? (
              <div className="flex items-center gap-1">
                <img
                  src={`${BASE_LOCAL_IMAGES_DIR}/${incoming_order_orange_arrow_IMG}`}
                  alt="outgoing_aqua_arrow"
                />
                <span className="font-semibold text-textPrimaryColor">{`#${row.Id}`}</span>
              </div>
            ) : (
              <div className="flex items-center gap-1">
                <img
                  src={`${BASE_LOCAL_IMAGES_DIR}/${incoming_order_blue_arrow_IMG}`}
                  alt="incoming_order_blue_arrow"
                />
                <span className="font-semibold text-textPrimaryColor">{`#${row.Id}`}</span>
              </div>
            )}
          </div>
        );
      }
      return noDataMessage;
    //?=============================Pharmacy Order Types========================
    case "PharmacyOrderDetailsName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        let images = row?.Offer?.Items?.map((OfferItem: IOfferItem) => {
          return OfferItem.Package !== null
            ? OfferItem.Package.Image
            : OfferItem.Product.CoverImage;
        });
        return (
          <div>
            {row?.Package !== null ? (
              <div className="flex items-center gap-1">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Package?.Image
                      ? `${BASE_Images_API_URL}/${row?.Package?.Image}`
                      : ""
                  }
                  alt="Drug_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <p>{row?.Package?.Name}</p>
              </div>
            ) : row?.Offer !== null ? (
              <div className="flex items-center gap-4">
                {images !== undefined && images.length === 1 ? (
                  <div className="h-16 w-16 overflow-hidden rounded-xl">
                    <GeneralImage
                      loading="lazy"
                      src={
                        images[0] !== ""
                          ? `${BASE_Images_API_URL}/${images[0]}`
                          : ""
                      }
                      alt="Offer_image"
                      className="h-full w-full object-cover"
                    />
                  </div>
                ) : (
                  <div className="grid h-16 w-16 grid-cols-2 grid-rows-2 rounded-xl">
                    {images?.slice(0, 4).map((img: string, index: number) => {
                      if (index === 3 && images.length > 4) {
                        return (
                          <div
                            key={index}
                            className="relative flex items-center justify-center overflow-hidden"
                          >
                            <GeneralImage
                              loading="lazy"
                              src={
                                img && img !== ""
                                  ? `${BASE_Images_API_URL}/${img}`
                                  : ""
                              }
                              alt={`-${index}`}
                              className="h-full w-full object-cover"
                            />
                          </div>
                        );
                      }
                      return (
                        <div className="rounded-xl" key={index}>
                          <GeneralImage
                            loading="lazy"
                            src={
                              img && img !== ""
                                ? `${BASE_Images_API_URL}/${img}`
                                : ""
                            }
                            alt={`-${index}`}
                            className="h-full w-full object-cover"
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="flex flex-col gap-2">
                  <p>{row?.Offer?.Name}</p>
                  <div className="flex items-center gap-1">
                    <GeneralImage
                      src={`${BASE_LOCAL_IMAGES_DIR}/${offer_icon_IMG}`}
                      alt="offer"
                      height={16}
                      width={16}
                    />
                    <p className="text-xs font-normal text-warningMain">
                      {i18next.t("offer")}
                    </p>
                  </div>
                </div>
              </div>
            ) : row?.Product !== null ? (
              <div className="flex items-center gap-1">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Product?.CoverImage
                      ? `${BASE_Images_API_URL}/${row?.Product?.CoverImage}`
                      : ""
                  }
                  alt="Product_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <p>{row?.Product.Name}</p>
              </div>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "PharmacyOrderDetailsBrandName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Package !== null ? (
              <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">
                {row?.Package?.Facility?.Name}
              </p>
            ) : row?.Offer !== null ? (
              <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">
                {row?.Offer.Facility?.Name ?? "-"}
              </p>
            ) : row?.Product !== null ? (
              <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">
                {row?.Product?.BrandName}
              </p>
            ) : (
              <div className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">
                {i18next.t("no_data_available")}
              </div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "PharmacyOrderDetailsPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Package !== null ? (
              <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">{`${formatPrice(
                Number(row?.Package?.NetPrice),
              )} ${row?.Currency?.Name}`}</p>
            ) : row?.Offer !== null ? (
              <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">{`${formatPrice(
                Number(row?.Offer?.TotalPriceAfterDiscount),
              )} ${row?.Currency?.Name}`}</p>
            ) : row?.Product !== null ? (
              <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">{`${formatPrice(
                Number(row?.Price),
              )} ${row?.Currency?.Name}`}</p>
            ) : (
              <div className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">
                {i18next.t("no_data_available")}
              </div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "PharmacyOrderDetailsQuantity":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">
            {row?.ApprovedQuantity ? row?.ApprovedQuantity : 0} /{" "}
            {row?.Quantity}
          </p>
        );
      }
      return noDataMessage;
    case "PharmacyOrderDetailsTotalPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        if (row.Status === OrderStatusEnum.PENDING) {
          return (
            <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">{`${formatPrice(
              row?.Price * row?.Quantity,
            )} ${row?.Currency?.Name}`}</p>
          );
        }
        return (
          <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">{`${formatPrice(
            row?.Price * row?.ApprovedQuantity,
          )} ${row?.Currency?.Name}`}</p>
        );
      }
      return noDataMessage;
    case "PharmacyOrderDetailsStatus":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p className="text-ellipsis text-wrap text-sm font-normal text-bodyTextColor">
            {row?.Status
              ? getOrderStatusBg(row?.Status, row?.CompletePercentage)
              : i18next.t("no_status")}
          </p>
        );
      }
      return noDataMessage;
    //?=============================Warehouse Order Types========================
    case "WarehouseOrderDetailsName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        let images = row?.Offer?.Items?.map((OfferItem: IOfferItem) => {
          return OfferItem.Package !== null
            ? OfferItem.Package.Image
            : OfferItem.Product.CoverImage;
        });
        return (
          <div>
            {row?.Package !== null ? (
              <div className="flex flex-col items-center gap-1 2xl:flex-row">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Package?.Image
                      ? `${BASE_Images_API_URL}/${row?.Package?.Image}`
                      : ""
                  }
                  alt="Drug_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <div className="flex flex-col">
                  <p>{row?.Package?.Name}</p>
                  <a
                    href="#"
                    data-tooltip-id="scientificName-tooltip"
                    data-tooltip-content={row?.Package?.ScientificName}
                  >
                    <p className="text-sm font-normal text-textColor">
                      {row?.Package?.ScientificName}
                    </p>
                  </a>
                  <Tooltip
                    id="scientificName-tooltip"
                    className="z-50 max-w-xl break-words break-all"
                  />
                </div>
              </div>
            ) : row?.Offer !== null ? (
              <div className="flex items-center gap-4">
                {images !== undefined && images.length === 1 ? (
                  <div className="h-16 w-16 overflow-hidden rounded-xl">
                    <GeneralImage
                      loading="lazy"
                      src={
                        images[0] !== ""
                          ? `${BASE_Images_API_URL}/${images[0]}`
                          : ""
                      }
                      alt="Offer_image"
                      className="h-full w-full object-cover"
                    />
                  </div>
                ) : (
                  <div className="grid h-16 w-16 grid-cols-2 grid-rows-2 rounded-xl">
                    {images?.slice(0, 4).map((img: string, index: number) => {
                      if (index === 3 && images.length > 4) {
                        return (
                          <div
                            key={index}
                            className="relative flex items-center justify-center overflow-hidden"
                          >
                            <GeneralImage
                              loading="lazy"
                              src={
                                img && img !== ""
                                  ? `${BASE_Images_API_URL}/${img}`
                                  : ""
                              }
                              alt={`-${index}`}
                              className="h-full w-full object-cover"
                            />
                          </div>
                        );
                      }
                      return (
                        <div className="rounded-xl" key={index}>
                          <GeneralImage
                            loading="lazy"
                            src={
                              img && img !== ""
                                ? `${BASE_Images_API_URL}/${img}`
                                : ""
                            }
                            alt={`-${index}`}
                            className="h-full w-full object-cover"
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="flex flex-col gap-1">
                  <p>{row?.Offer?.Name}</p>
                  <div className="flex items-center gap-1">
                    <GeneralImage
                      src={`${BASE_LOCAL_IMAGES_DIR}/${offer_icon_IMG}`}
                      alt="offer"
                      height={16}
                      width={16}
                    />
                    <p className="text-xs font-normal text-warningMain">
                      {i18next.t("offer")}
                    </p>
                  </div>
                </div>
              </div>
            ) : row?.Product !== null ? (
              <div className="flex items-center gap-1">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Product?.CoverImage
                      ? `${BASE_Images_API_URL}/${row?.Product?.CoverImage}`
                      : ""
                  }
                  alt="Product_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <p>{row?.Product.Name}</p>
              </div>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseOrderDetailsBrandName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Package !== null ? (
              <p>
                {row?.Package?.Facility?.Name
                  ? row?.Package?.Facility?.Name
                  : noDataMessage}
              </p>
            ) : row?.Offer !== null ? (
              <p>
                {row?.Offer?.Facility
                  ? row?.Offer?.Facility?.Name
                  : noDataMessage}
              </p>
            ) : row?.Product !== null ? (
              <p>{row?.Product?.BrandName}</p>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseOrderDetailsPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Price ? (
              `${formatPrice(Number(row?.Price))} ${row?.Currency?.Name}`
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseOrderDetailsQuantity":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.ApprovedQuantity
              ? `${row?.ApprovedQuantity}/${row?.Quantity}`
              : `${row?.Quantity}`}
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseOrderDetailsTotalPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row.ApprovedQuantity > 0
              ? `${formatPrice(Number(row?.Price * row?.ApprovedQuantity))} ${
                  row?.Currency?.Name
                }`
              : `${formatPrice(Number(row?.Price * row?.Quantity))} ${
                  row?.Currency?.Name
                }`}
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseOrderDetailsStatus":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Status
              ? getOrderStatusBg(row?.Status, row?.CompletePercentage)
              : i18next.t("no_status")}
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseOrderType":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return row.Type === OrderTypesEnum.ALL ? (
          <div className="w-fit rounded-md bg-warningMain px-4 py-1 text-center text-xs font-semibold text-warningLighter 2xl:text-sm">
            {i18next.t("for_all")}
          </div>
        ) : (
          <div className="w-fit rounded-md bg-primaryLighter px-4 py-1 text-center text-xs font-semibold text-primaryMain 2xl:text-sm">
            {i18next.t("for_me")}
          </div>
        );
      }
      return noDataMessage;
    //?=============================Warehouse Request Order Types========================
    case "WarehouseRequestOrderDetailsName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        let images = row?.Offer?.Items?.map((OfferItem: IOfferItem) => {
          return OfferItem.Package !== null
            ? OfferItem.Package.Image
            : OfferItem.Product.CoverImage;
        });
        return (
          <div>
            {row?.Package !== null ? (
              <div className="flex flex-wrap items-center gap-1">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Package?.Image
                      ? `${BASE_Images_API_URL}/${row?.Package?.Image}`
                      : ""
                  }
                  alt="Drug_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <div className="flex flex-col">
                  <p className="text-ellipsis text-sm text-textPrimaryColor">
                    {`${row?.Package?.Name?.slice(0, 20)}...`}
                  </p>
                  <a
                    data-tooltip-id="scientificName-tooltip"
                    data-tooltip-content={row?.Package?.ScientificName}
                  >
                    <p className="text-sm font-normal text-textColor">
                      {row?.Package?.ScientificName?.slice(0, 20)}
                    </p>
                  </a>
                  <Tooltip
                    id="scientificName-tooltip"
                    className="z-50 max-w-xl break-words break-all"
                  />
                </div>
              </div>
            ) : row?.Offer !== null ? (
              <div className="flex items-center gap-4">
                {images !== undefined && images.length === 1 ? (
                  <div className="h-16 min-h-16 w-16 min-w-16 overflow-hidden rounded-xl">
                    <GeneralImage
                      loading="lazy"
                      src={
                        images[0] !== ""
                          ? `${BASE_Images_API_URL}/${images[0]}`
                          : ""
                      }
                      alt="Offer_image"
                      className="h-full w-full object-cover"
                    />
                  </div>
                ) : (
                  <div className="grid h-16 w-16 grid-cols-2 grid-rows-2 rounded-xl">
                    {images?.slice(0, 4).map((img: string, index: number) => {
                      if (index === 3 && images.length > 4) {
                        return (
                          <div
                            key={index}
                            className="overflow-hidde relative flex items-center justify-center"
                          >
                            <GeneralImage
                              loading="lazy"
                              src={
                                img && img !== ""
                                  ? `${BASE_Images_API_URL}/${img}`
                                  : ""
                              }
                              alt={`-${index}`}
                              className="h-full w-full object-cover"
                            />
                          </div>
                        );
                      }
                      return (
                        <div className="rounded-xl" key={index}>
                          <GeneralImage
                            loading="lazy"
                            src={
                              img && img !== ""
                                ? `${BASE_Images_API_URL}/${img}`
                                : ""
                            }
                            alt={`-${index}`}
                            className="h-full w-full object-cover"
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="flex flex-col gap-1">
                  <p>{row?.Offer?.Name}</p>
                  <div className="flex items-center gap-1">
                    <GeneralImage
                      src={`${BASE_LOCAL_IMAGES_DIR}/${offer_icon_IMG}`}
                      alt="offer"
                      height={16}
                      width={16}
                    />
                    <p className="text-xs font-normal text-warningMain">
                      {i18next.t("offer")}
                    </p>
                  </div>
                </div>
              </div>
            ) : row?.Product !== null ? (
              <div className="flex items-center gap-1">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Product?.CoverImage
                      ? `${BASE_Images_API_URL}/${row?.Product?.CoverImage}`
                      : ""
                  }
                  alt="Product_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <p className="text-sm text-textPrimaryColor">
                  {row?.Product.Name}
                </p>
              </div>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseRequestOrderDetailsBrandName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Package !== null ? (
              <p className="text-sm text-textPrimaryColor">
                {row?.Package?.Facility?.Name
                  ? row?.Package?.Facility?.Name
                  : noDataMessage}
              </p>
            ) : row?.Offer !== null ? (
              <p className="text-sm text-textPrimaryColor">
                {row?.Offer?.Facility?.Name
                  ? row?.Offer?.Facility?.Name
                  : noDataMessage}
                -
              </p>
            ) : row?.Product !== null ? (
              <p className="text-sm text-textPrimaryColor">
                {row?.Product?.BrandName}
              </p>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseRequestOrderDetailsMaxQuantity":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return <p>{row?.Quantity}</p>;
      }
      return noDataMessage;

    case "PatientOrderRequestDetailsPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            <p className="text-sm text-textPrimaryColor">{`${formatPrice(
              row?.Price,
            )} ${row?.Currency?.Name}`}</p>
          </div>
        );
      }
      return noDataMessage;
    case "PatientOrderRequestDetailsQuantity":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            <p className="text-sm text-textPrimaryColor">{`${
              row?.Quantity
            } ${i18next.t("item")}`}</p>
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseRequestOrderDetailsPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Package !== null ? (
              <p className="text-sm text-textPrimaryColor">{`${formatPrice(
                row?.Price,
              )} ${row?.Currency?.Name}`}</p>
            ) : row?.Offer !== null ? (
              <p className="text-sm text-textPrimaryColor">{`${formatPrice(
                Number(row?.Price),
              )} ${row?.Currency?.Name}`}</p>
            ) : row?.Product !== null ? (
              <p className="text-sm text-textPrimaryColor">{`${formatPrice(
                Number(row?.Price),
              )} ${row?.Currency?.Name}`}</p>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "WarehouseRequestOrderDetailsTotalPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>{`${formatPrice(row?.Price * row?.Quantity)} ${
            row?.Currency?.Name
          }`}</div>
        );
      }
      return;
    //?=============================TimeOut Table Types========================
    case "TimeOverRequestReviewDetailsName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        let images = row?.Offer?.Items?.map((OfferItem: IOfferItem) => {
          return OfferItem.Package !== null
            ? OfferItem.Package.Image
            : OfferItem.Product.CoverImage;
        });
        return (
          <div>
            {row?.Package !== null ? (
              <div className="flex items-center gap-1">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Package?.Image
                      ? `${BASE_Images_API_URL}/${row?.Package?.Image}`
                      : ""
                  }
                  alt="Drug_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <div className="flex flex-col">
                  <p>{row?.Package?.Name}</p>
                  <a
                    href="#"
                    data-tooltip-id="scientificName-tooltip"
                    data-tooltip-content={row?.Package?.ScientificName}
                  >
                    <p className="text-sm font-normal text-textColor">
                      {row?.Package?.ScientificName}
                    </p>
                  </a>
                  <Tooltip
                    id="scientificName-tooltip"
                    className="z-50 max-w-xl break-words break-all"
                  />
                </div>
              </div>
            ) : row?.Offer !== null ? (
              <div className="flex items-center gap-4">
                {images !== undefined && images.length === 1 ? (
                  <div className="h-16 w-16 overflow-hidden rounded-xl">
                    <GeneralImage
                      loading="lazy"
                      src={
                        images[0] !== ""
                          ? `${BASE_Images_API_URL}/${images[0]}`
                          : ""
                      }
                      alt="Offer_image"
                      className="h-full w-full object-cover"
                    />
                  </div>
                ) : (
                  <div className="grid h-16 w-16 grid-cols-2 grid-rows-2 rounded-xl">
                    {images?.slice(0, 4).map((img: string, index: number) => {
                      if (index === 3 && images.length > 4) {
                        return (
                          <div
                            key={index}
                            className="overflow-hidde relative flex items-center justify-center"
                          >
                            <GeneralImage
                              loading="lazy"
                              src={
                                img && img !== ""
                                  ? `${BASE_Images_API_URL}/${img}`
                                  : ""
                              }
                              alt={`-${index}`}
                              className="h-full w-full object-cover"
                            />
                          </div>
                        );
                      }
                      return (
                        <div className="rounded-xl" key={index}>
                          <GeneralImage
                            loading="lazy"
                            src={
                              img && img !== ""
                                ? `${BASE_Images_API_URL}/${img}`
                                : ""
                            }
                            alt={`-${index}`}
                            className="h-full w-full object-cover"
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                <p>{row?.Offer?.Name}</p>
              </div>
            ) : row?.Product !== null ? (
              <div className="flex items-center gap-1">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Product?.CoverImage
                      ? `${BASE_Images_API_URL}/${row?.Product?.CoverImage}`
                      : ""
                  }
                  alt="Product_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <p>{row?.Product.Name}</p>
              </div>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "TimeOverRequestReviewDetailsBrandName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Package !== null ? (
              <p>
                {row?.Package?.Facility?.Name
                  ? row?.Package?.Facility?.Name
                  : noDataMessage}
              </p>
            ) : row?.Offer !== null ? (
              <p>{row?.Offer.Name ? row?.Offer.Name : noDataMessage}</p>
            ) : row?.Product !== null ? (
              <p>{row?.Product?.Facility?.Name}</p>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "TimeOverRequestReviewDetailsPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row?.Package !== null ? (
              <p>{`${formatPrice(Number(row?.Package?.NetPrice))} ${
                row?.Currency?.Name
              }`}</p>
            ) : row?.Offer !== null ? (
              <p>{`${formatPrice(
                Number(row?.Offer?.TotalPriceAfterDiscount),
              )} ${row?.Currency?.Name}`}</p>
            ) : row?.Product !== null ? (
              <p>{`${formatPrice(Number(row?.Product?.NetPrice))} ${
                row?.Currency?.Name
              }`}</p>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "TimeOverRequestReviewDetailsQuantity":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <div>
            {row.SelectedQuantity !== null
              ? row.SelectedQuantity
              : row?.Quantity}
          </div>
        );
      }
      return noDataMessage;
    case "TimeOverRequestReviewDetailsTotalPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p>{`${
            row?.SelectedQuantity > 0
              ? formatPrice(row?.Price * row?.SelectedQuantity)
              : formatPrice(row?.Price * row?.Quantity)
          } ${row?.Currency?.Name}`}</p>
        );
      }
      return;
    //?======================Shared Cart Table Types========================
    case "SharedCartTableName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        //?============Render Offer Images================
        if (row?.Offer) {
          const renderImages = (offerItems: any) => {
            if (!offerItems || offerItems.length === 0) return null;

            const imgSrcs = offerItems.map((item: any) =>
              item?.Package ? item?.Package?.Image : item?.Product?.CoverImage,
            );
            const validImages = imgSrcs.filter(
              (src: string | undefined) => src !== undefined,
            );

            //? If there's only one offer item, display it directly
            if (validImages.length === 1) {
              return (
                <GeneralImage
                  src={`${BASE_Images_API_URL}/${validImages[0]}`}
                  alt="Offer"
                  loading="lazy"
                  className="h-14 w-14 rounded-xl object-cover"
                />
              );
            }

            //? If there are two offer items, display them side by side
            if (validImages.length === 2) {
              return (
                <div className="grid h-full w-full grid-cols-2 grid-rows-1 gap-2">
                  {validImages.map((imgSrc: string, index: number) => (
                    <GeneralImage
                      key={index}
                      src={`${BASE_Images_API_URL}/${imgSrc}`}
                      alt={`Offer_${index}`}
                      loading="lazy"
                      className="h-14 w-14 rounded-xl object-cover"
                    />
                  ))}
                </div>
              );
            }

            //? If there are three or more offer items, display in a grid with a maximum of 4 images
            return (
              <div className="grid h-full grid-cols-2 grid-rows-2 gap-1 overflow-hidden">
                {validImages
                  .slice(0, 4)
                  .map((imgSrc: string, index: number) => {
                    if (index === 3 && validImages.length > 4) {
                      return (
                        <div
                          key={index}
                          className="relative flex h-full items-center justify-center overflow-hidden rounded-xl bg-gray-200"
                        >
                          <GeneralImage
                            src={`${BASE_Images_API_URL}/${imgSrc}`}
                            alt={`Offer_${index}`}
                            loading="lazy"
                            className="h-6 w-6 object-cover"
                          />
                          <div className="absolute inset-0 flex items-center justify-center bg-primaryLighter bg-opacity-100 text-sm font-semibold text-primaryMain">
                            +{validImages.length - 3}
                          </div>
                        </div>
                      );
                    }

                    return (
                      <GeneralImage
                        key={index}
                        src={`${BASE_Images_API_URL}/${imgSrc}`}
                        alt={`Offer_${index}`}
                        loading="lazy"
                        className="h-6 w-6 rounded-xl object-cover"
                      />
                    );
                  })}
              </div>
            );
          };

          return (
            <div className="flex items-center gap-2">
              {row?.Offer.Items?.length > 0 && (
                <div className="h-12 w-12">
                  {renderImages(row?.Offer.Items)}
                </div>
              )}

              <p>
                {row?.Offer?.Name ?? row?.Offer?.NameEn ?? row?.Offer?.NameAr}
              </p>
            </div>
          );
        }

        if (row?.Package) {
          return row.Package.Name ?? row.Package.NameEn ?? row.Package.NameAr;
        }

        if (row?.Product) {
          return row.Product.Name ?? row.Product.NameEn ?? row.Product.NameAr;
        }
        return "-";
      }
      return noDataMessage;

    case "SharedCartTableQuantity":
      if (row === null) {
        return;
      }
      if (row !== null) {
        const GroupedTableRowData = { row, Facility: extraRowPayload };

        return (
          <SharedCartTableItemQuantityItem TableRow={GroupedTableRowData} />
        );
      }
      return noDataMessage;

    //?=============================Cart Table Types========================
    case "CartTableName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        //?============Render Offer Images================
        const renderImages = (offerItems: any) => {
          if (!offerItems || offerItems.length === 0) return null;

          const imgSrcs = offerItems.map((item: any) =>
            item?.Package ? item?.Package?.Image : item?.Product?.CoverImage,
          );
          const validImages = imgSrcs.filter(
            (src: string | undefined) => src !== undefined,
          );

          //? If there's only one offer item, display it directly
          if (validImages.length === 1) {
            return (
              <GeneralImage
                src={`${BASE_Images_API_URL}/${validImages[0]}`}
                alt="Offer"
                loading="lazy"
                className="h-14 w-14 rounded-xl object-cover"
              />
            );
          }

          //? If there are two offer items, display them side by side
          if (validImages.length === 2) {
            return (
              <div className="grid h-full w-full grid-cols-2 grid-rows-1 gap-2">
                {validImages.map((imgSrc: string, index: number) => (
                  <GeneralImage
                    key={index}
                    src={`${BASE_Images_API_URL}/${imgSrc}`}
                    alt={`Offer_${index}`}
                    loading="lazy"
                    className="h-14 w-14 rounded-xl object-cover"
                  />
                ))}
              </div>
            );
          }

          //? If there are three or more offer items, display in a grid with a maximum of 4 images
          return (
            <div className="grid h-full grid-cols-2 grid-rows-2 gap-1 overflow-hidden">
              {validImages.slice(0, 4).map((imgSrc: string, index: number) => {
                if (index === 3 && validImages.length > 4) {
                  return (
                    <div
                      key={index}
                      className="relative flex h-full items-center justify-center overflow-hidden rounded-xl bg-gray-200"
                    >
                      <GeneralImage
                        src={`${BASE_Images_API_URL}/${imgSrc}`}
                        alt={`Offer_${index}`}
                        loading="lazy"
                        className="h-6 w-6 object-cover"
                      />
                      <div className="absolute inset-0 flex items-center justify-center bg-primaryLighter bg-opacity-100 text-sm font-semibold text-primaryMain">
                        +{validImages.length - 3}
                      </div>
                    </div>
                  );
                }

                return (
                  <GeneralImage
                    key={index}
                    src={`${BASE_Images_API_URL}/${imgSrc}`}
                    alt={`Offer_${index}`}
                    loading="lazy"
                    className="h-6 w-6 rounded-xl object-cover"
                  />
                );
              })}
            </div>
          );
        };
        return (
          <div className="flex items-center gap-2">
            {row?.offerId ? (
              <div className="h-12 w-12">{renderImages(row?.offerItems)}</div>
            ) : (
              <GeneralImage
                src={row?.image ? `${BASE_Images_API_URL}/${row.image}` : ""}
                alt="cart"
                loading="lazy"
                className="h-14 w-14 rounded-xl object-cover"
              />
            )}

            <p>{row?.name}</p>
          </div>
        );
      }
      return noDataMessage;
    case "CartTablePrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor lg:text-lg">
            {`${formatPrice(row?.price)} ${i18next.language === ArabicCode ? row?.currency?.NameAr : row?.currency?.NameEn}`}
          </p>
        );
      }
      return noDataMessage;
    case "CartTableQuantity":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return <CartTableItemQuantityItem TableRow={row} />;
      }
      return noDataMessage;
    case "CartTableTotalPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-bodyTextColor lg:text-lg">
            {`${formatPrice(row?.price * row?.quantity)} ${i18next.language === ArabicCode ? row?.currency?.NameAr : row?.currency?.NameEn}`}
          </p>
        );
      }
      return;
    //?=============================Excel Drug Table Types========================
    case "ImportedSuccessExcelDataDrugName":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return RowValue != null ? (
          <div className="flex flex-col items-center gap-2 lg:flex-row">
            <GeneralImage
              loading="lazy"
              src={row.Image ? `${BASE_Images_API_URL}/${row.Image}` : ""}
              alt={RowValue}
              className="h-16 w-16 rounded-lg object-cover"
            />
            <div className="flex flex-col">
              <p className="text-sm font-normal text-headingTextColor">
                {RowValue}
              </p>
            </div>
          </div>
        ) : (
          noDataMessage
        );
      }
      return noDataMessage;
    case "ImportedSuccessExcelDataDrugBrandName":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <div>
            {row !== null ? (
              <p className="text-ellipsis text-sm font-normal text-textPrimaryColor">
                {row?.Facility?.Name ? row?.Facility?.Name : noDataMessage}
              </p>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "ImportedSuccessExcelDataDrugDosageForm":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-textPrimaryColor">
            {row?.Drug?.DosageForm
              ? row?.Drug?.DosageForm?.Name
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "ImportedSuccessExcelDataDrugDosage":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-textPrimaryColor">
            {row?.Drug?.RouteOfAdministration
              ? row?.Drug?.RouteOfAdministration?.Name
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "ImportedSuccessExcelDataDrugNetPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-textPrimaryColor">
            {row?.NetPrice
              ? `${formatPrice(row?.NetPrice)} ${
                  row?.Currency ? row?.Currency?.Name : ""
                }`
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    case "ImportedSuccessExcelDataDrugSellingPrice":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return (
          <p className="text-ellipsis text-sm font-normal text-textPrimaryColor">
            {row?.SellingPrice
              ? `${formatPrice(row?.SellingPrice)} ${
                  row?.Currency ? row?.Currency?.Name : ""
                }`
              : noDataMessage}
          </p>
        );
      }
      return noDataMessage;
    //?=============================Import Execl========================
    case "excel_product_name":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <div className="flex items-center gap-2">
            <GeneralImage
              src={`${BASE_Images_API_URL}/${DefaultProductExcelImage}`}
              alt="default_image"
              className="h-12 w-12"
            />
            <p className="text-sm font-normal text-headingTextColor">
              {RowValue}
            </p>
          </div>
        );
      }
      return noDataMessage;
    case "order_pharmacy_date_of_delivery":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        if (
          row?.Type === OrderTypesEnum.SPECIFIC ||
          row?.Type === OrderTypesEnum.RETURNED
        ) {
          if (row?.Status === OrderStatusEnum.PENDING) {
            return (
              <p className="text-ellipsis text-sm font-normal text-textPrimaryColor">
                {`${convertTimestampToDate(
                  row.FromDate,
                )} - ${convertTimestampToDate(row.ToDate)}`}
              </p>
            );
          }
          if (
            row?.Status === OrderStatusEnum.ACCEPTED ||
            row?.Status === OrderStatusEnum.ACCEPTEDPARTIALLY
          ) {
            return convertTimestampToDate(row?.DeliveryDate);
          } else if (
            row?.Status === OrderStatusEnum.REJECTED ||
            row?.Status === OrderStatusEnum.CANCELED ||
            row?.Status === OrderStatusEnum.EXPIRED
          ) {
            return "-";
          }
        } else if (row?.Type === OrderTypesEnum.ALL) {
          if (
            row?.Status !== OrderStatusEnum.REJECTED &&
            row?.Status !== OrderStatusEnum.CANCELED &&
            row?.Status !== OrderStatusEnum.EXPIRED
          ) {
            return (
              <p className="text-ellipsis text-sm font-normal text-textPrimaryColor">
                {`${convertTimestampToDate(
                  row.FromDate,
                )} - ${convertTimestampToDate(row.ToDate)}`}
              </p>
            );
          } else {
            return "-";
          }
        }
      }
      return noDataMessage;
    case "order_warehouse_date_of_delivery":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        if (
          row?.Type === OrderTypesEnum.SPECIFIC ||
          row?.Type === OrderTypesEnum.RETURNED
        ) {
          if (
            row?.Status === OrderStatusEnum.ACCEPTED ||
            row?.Status === OrderStatusEnum.ACCEPTEDPARTIALLY
          ) {
            return convertTimestampToDate(row?.DeliveryDate);
          } else if (
            row?.Status === OrderStatusEnum.REJECTED ||
            row?.Status === OrderStatusEnum.CANCELED ||
            row?.Status === OrderStatusEnum.EXPIRED
          ) {
            return "-";
          }
        } else if (row?.Type === OrderTypesEnum.ALL) {
          if (
            row?.Status === OrderStatusEnum.ACCEPTED ||
            row?.Status === OrderStatusEnum.ACCEPTEDPARTIALLY
          ) {
            return convertTimestampToDate(row?.DeliveryDate);
          } else if (
            row?.Status !== OrderStatusEnum.REJECTED &&
            row?.Status !== OrderStatusEnum.EXPIRED
          ) {
            return (
              <p className="text-ellipsis text-sm font-normal text-textPrimaryColor">
                {`${convertTimestampToDate(
                  row.FromDate,
                )} - ${convertTimestampToDate(row.ToDate)}`}
              </p>
            );
          } else {
            return "-";
          }
        }
      }
      return noDataMessage;
    //?================== Returned Order ========================
    case "ReturnOrderName":
      if (row === null) {
        return noDataMessage;
      }

      if (row !== null) {
        let images = row?.Offer?.Items?.map((OfferItem: IOfferItem) => {
          return OfferItem.Package !== null
            ? OfferItem.Package.Image
            : OfferItem.Product.CoverImage;
        });
        return (
          <div>
            {row?.Package !== null ? (
              <div className="flex items-center gap-1">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Package?.Image
                      ? `${BASE_Images_API_URL}/${row?.Package?.Image}`
                      : ""
                  }
                  alt="Drug_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <p className="text-sm text-bodyTextColor">
                  {row?.Package?.Name}
                </p>
              </div>
            ) : row?.Offer !== null ? (
              <div className="flex items-center gap-4">
                {images !== undefined && images.length === 1 ? (
                  <div className="h-16 w-16 overflow-hidden rounded-xl">
                    <GeneralImage
                      loading="lazy"
                      src={
                        images[0] !== ""
                          ? `${BASE_Images_API_URL}/${images[0]}`
                          : ""
                      }
                      alt="Offer_image"
                      className="h-16 w-16 rounded-xl object-cover"
                    />
                  </div>
                ) : (
                  <div className="grid h-16 w-16 grid-cols-2 grid-rows-2 rounded-xl">
                    {images?.slice(0, 4).map((img: string, index: number) => {
                      if (index === 3 && images.length > 4) {
                        return (
                          <div
                            key={index}
                            className="relative flex items-center justify-center overflow-hidden"
                          >
                            <GeneralImage
                              loading="lazy"
                              src={
                                img && img !== ""
                                  ? `${BASE_Images_API_URL}/${img}`
                                  : ""
                              }
                              alt={`-${index}`}
                              className="h-6 w-6 rounded-xl object-cover"
                            />
                          </div>
                        );
                      }
                      return (
                        <div className="rounded-xl" key={index}>
                          <GeneralImage
                            loading="lazy"
                            src={
                              img && img !== ""
                                ? `${BASE_Images_API_URL}/${img}`
                                : ""
                            }
                            alt={`-${index}`}
                            className="h-6 w-6 rounded-xl object-cover"
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                <p className="text-sm text-bodyTextColor">{row?.Offer?.Name}</p>
              </div>
            ) : row?.Product !== null ? (
              <div className="flex items-center gap-1">
                <GeneralImage
                  loading="lazy"
                  src={
                    row?.Product?.CoverImage
                      ? `${BASE_Images_API_URL}/${row?.Product?.CoverImage}`
                      : ""
                  }
                  alt="Product_Image"
                  className="h-16 w-16 rounded-xl object-cover"
                />
                <p className="text-sm text-bodyTextColor">
                  {row?.Product.Name}
                </p>
              </div>
            ) : (
              <div>{i18next.t("no_data_available")}</div>
            )}
          </div>
        );
      }
      return noDataMessage;
    case "ReturnOrderQuantity":
      if (row === null) {
        return;
      }
      if (row !== null) {
        return <ReturnedOrderTableQuantityItem TableRow={row} />;
      }
      return noDataMessage;
    case "ReturnOrderTotalQuantity":
      if (row === null) {
        return noDataMessage;
      }
      if (row !== null) {
        return (
          <p className="text-sm text-bodyTextColor">{row?.ApprovedQuantity}</p>
        );
      }
      return noDataMessage;

    default:
      return noDataMessage;
  }
};

export const HandleEnvVariable = async () => {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    if (config.Environment) {
      return config.Environment;
    } else {
      console.error("Environment variable not found in config.json");
      return null;
    }
  } catch (error) {
    console.error("Error fetching config.json:", error);
    return null;
  }
};

export const truncateString = (value?: string, max = 30) => {
  if (!value) return "";
  return value.length <= max ? value : `${value.slice(0, max)}...`;
};

export const normalizeId = (id?: number | null): number | null => {
  return id && id > 0 ? id : null;
};

export const mapApiItemToSharedCartItem = (
  item: any,
  facility: any,
): SharedCartItem => {
  const entity = item.Package ?? item.Product ?? item.Offer;

  if (!entity) {
    throw new Error("Invalid cart item: no Package, Product, or Offer");
  }

  const itemType: SharedCartItemType = item.Package
    ? "package"
    : item.Product
      ? "product"
      : "offer";

  return {
    productId: normalizeId(item.Product?.Id),
    offerId: normalizeId(item.Offer?.Id),
    packageId: normalizeId(item.Package?.Id),
    quantity: item.Quantity ?? 1,

    price:
      item.Package?.NetPrice ??
      item.Product?.NetPrice ??
      item.Offer?.TotalPriceAfterDiscount ??
      item.Offer?.TotalPrice ??
      0,

    image: item.Package?.Image ?? item.Product?.CoverImage ?? null,

    name: entity.Name,
    nameAr: entity.NameAr ?? null,
    nameEn: entity.NameEn ?? null,

    warehouse: facility ?? null,
    itemType,
    currency: entity.Currency ?? null,
  };
};

export const mapSharedCartResponse = (
  carts: ISharedCart[] | undefined,
): INormalizedSharedCart[] => {
  if (!carts?.length) return [];

  return carts.map((cart) => ({
    Facility: cart.Facility ?? null,
    TotalPrice: cart.TotalPrice,
    Items: cart.Items.map((item) =>
      mapApiItemToSharedCartItem(item, cart.Facility),
    ),
  }));
};

export const mapApiCartsToSharedCartOrders = (
  carts: INormalizedSharedCart[],
): SharedCartOrder[] => {
  return carts?.map((cart) => ({
    type: cart.Facility ? "SPECIFIC" : "ALL",
    warehouse: cart.Facility ?? undefined,
    items: cart.Items.map((item) => ({
      ...item,
      name: item.name ?? "",
      nameAr: item.nameAr ?? "",
      nameEn: item.nameEn ?? "",
      image: item.image ?? "",
      quantity: item.quantity,
      warehouse: item.warehouse ?? null,
      currency: item.currency ?? undefined,
    })),
    totalprice: cart.Items.reduce((sum, i) => sum + i.price * i.quantity, 0),
  }));
};

export const mapSharedCartOrdersToApiPayload = (orders: SharedCartOrder[]) => {
  const carts = orders.map((order) => ({
    FacilityId: normalizeId(order.warehouse?.Id),
    Items: order.items.map((item) => ({
      PackageId: normalizeId(item.packageId),
      ProductId: normalizeId(item.productId),
      OfferId: normalizeId(item.offerId),
      Quantity: item.quantity ?? 1,
    })),
  }));

  return { Carts: carts };
};
